import SwaggerClient from 'swagger-client';
import router from '../router';
import store from '@/store';
import * as Tools from './../Tools/Tools'
import * as Json2Svg from './../Tools/json2svg';

import TclClient from './../Tools/orFlowWuia'
import TclAPI from './../Tools/tclAPI'
import AgentAPI from './../Tools/agentAPI'
import Logger from "./../Tools/logger"
import LibraryTypes from '@/constants/LibraryTypes'


var TCL = new TclClient();
window.TCL = TCL;

var agentAPI = new AgentAPI();
window.agentAPI = agentAPI;

var tclAPI = new TclAPI();
window.tclAPI = tclAPI;

var log = new Logger();
window.log = log;

tclAPI.initTCL(true)
.then(function(data) {
  console.log("initTCL ok");
  console.log(data)
  return store.dispatch('checkIfPlugin', true).then(
    ()=>{
      console.log('registering for rpc');
      agentAPI.rpcSubscribe("RpcSample",RpcDelegate);
      
    }
  );
  

}, function (reason) {
  console.log("initTCL error: "  + reason);

  store.dispatch('checkIfPlugin', false);
});


agentAPI.checkAvailability(true)
.then(function(data) {
  console.log("initAgent ok");
  console.log(data)
  return store.dispatch('checkIfAgent', data)
  .then(()=>{
    //console.log('registering for rpc');
    agentAPI.rpcSubscribe("LibSync",EventsRpcHandler);
  });

}, function (reason) {
  console.log("initAgent error: "  + reason);

  return store.dispatch('checkIfAgent', false);
});






var specUrl = '/api/v3/docs/swagger.json'; // data urls are OK too 'data:application/json;base64,abc...'

//const authorizations = {
 // authorizations: {
      // Type of auth, is inferred from the specification provided
      //my_basic_auth: { username: 'Admin', password: 'admin' },
      //my_query_auth: 'Bearer ' +  localStorage.getItem('token'),
      //my_header_auth: 'Bearer ' +  localStorage.getItem('token'),
      //Authorization: `Bearer ${localStorage.getItem('token')}`
      //my_oauth2_token: { token: { access_token: 'Bearer ' +  localStorage.getItem('token')} },

  //  }
//}
//console.log(authorizations)

var swaggerClient = new SwaggerClient(specUrl, {
  requestInterceptor: (req) => {
    
    req.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    return req;
  },
});

var swaggerClientFile = new SwaggerClient(specUrl, {
  requestInterceptor: (req) => {
    req.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    req.headers['Content-Type'] = 'multipart/form-data';
    return req;
  },
});
//var client;

var swaggerClient = swaggerClient
.then(function (swaggerClient) {

  var apiWrapper = {}
  for (var ctr in swaggerClient.apis){
    //console.log(ctr);
    //console.log(swaggerClient.apis[ctr])
    apiWrapper[ctr]={};
    for(var nm in swaggerClient.apis[ctr]){
      let nmSplet = nm.split('_');
      let nmModule = nmSplet[0];
      let nmController = nmSplet[1];
      let nmMethod = nmSplet[2];
      if(apiWrapper[nmModule]===undefined){
        apiWrapper[nmModule]={};
      }
      if(apiWrapper[nmModule][nmController]===undefined){
        apiWrapper[nmModule][nmController]={};
      }
      apiWrapper[nmModule][nmController][nmMethod] = swaggerClient.apis[ctr][nm];
      //console.log(nm);
    }
  }


  return new Promise(function(resolve, reject){
    //console.log("__________________________")
      //console.log(apiWrapper)
      //resolve(swaggerClient.apis);
      resolve(apiWrapper);
  })

}, function (reason) {
    console.log("failed to load the spec: ");
    console.log(reason);
})



var swaggerClientFile = swaggerClientFile
.then(function (swaggerClient) {

  var apiWrapper = {}
  for (var ctr in swaggerClient.apis){
    //console.log(ctr);
    //console.log(swaggerClient.apis[ctr])
    apiWrapper[ctr]={};
    for(var nm in swaggerClient.apis[ctr]){
      let nmSplet = nm.split('_');
      let nmModule = nmSplet[0];
      let nmController = nmSplet[1];
      let nmMethod = nmSplet[2];
      if(apiWrapper[nmModule]===undefined){
        apiWrapper[nmModule]={};
      }
      if(apiWrapper[nmModule][nmController]===undefined){
        apiWrapper[nmModule][nmController]={};
      }
      apiWrapper[nmModule][nmController][nmMethod] = swaggerClient.apis[ctr][nm];
      //console.log(nm);
    }
  }


  return new Promise(function(resolve, reject){
    //console.log("__________________________")
      //console.log(apiWrapper)
      //resolve(swaggerClient.apis);
      resolve(apiWrapper);
  })

}, function (reason) {
    console.log("failed to load the spec: ");
    console.log(reason);
}
  )

function checkConnection(result){

  if (result.status == 200){
    if (result.obj.status == "OK"){
      return true;
    }else{
      store.dispatch('setAlert', {where:this.$vnode.tag, what:result.obj.message});
      return false;
    }

  }else{

    store.dispatch('setAlert', {where:this.$vnode.tag, what:"Problem connecting to API"});
    return false;
  }


}

function checkReason(result){
  console.log("Reason:", result.obj.message);

  if (result.obj.message == "Authorization failure."){
    
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('role');
    localStorage.removeItem('userId');
    store.dispatch('logout');

    router.push({path: '/login'});
  } else {
    console.log({where:"api", what: result.obj.message})
    store.dispatch('setAlert', {where:"api", what:result.obj.message});
  }

}

function selectCategoryChecker(main, categoryId, commitType) {
  
    let obj = Object.assign({}, main);
    
    store.commit(commitType, obj);

  let trig = false;  
  
  if (categoryId == main.categoryId) {
    
    let obj = Object.assign({}, main);
    obj.children = [];
    
    store.commit(commitType, obj);
    trig = true;
  }

  if (main.children.length > 0 && trig == false) {
    
    categoriesChildren(main, main.children, categoryId, commitType);
  }

}
function categoriesChildren(main, children, categoryId, commitType) {
  
  let trig = false;
  for (var i = 0, lei = children.length; i < lei; i++) {

    if (categoryId == children[i].categoryId) {
      trig = true;
      let obj = Object.assign({}, children[i]);
      obj.children = [];
      
      
      store.commit(commitType, obj);
      break;
    }
    
    if (trig != true) {
      if (children[i].children.length > 0) {
        
        categoriesChildren(main, children[i].children, categoryId, commitType);
      }
    }
    

  }
  
 
}


function RpcDelegate(inputData) {
  console.log('rpc concatination delegate called');
  console.log(inputData);
  
    let syncLibraryFilesResult = inputData.parameters;
    if (syncLibraryFilesResult.requiredConcatinations.length>0) {
      if (store.getters.isPlugin) {
        let concatErrors = [];

        let chainedConcatPromises = $.Deferred().resolve(null).promise();
        for (let concatParams of syncLibraryFilesResult.requiredConcatinations) {
          chainedConcatPromises = chainedConcatPromises.then(
            function() {
              return tclAPI.concatOlb(concatParams.sourceFolderPath,concatParams.targetOlbFilePath);
            }/*,
            function(err) {
              console.log('olb concat error: '+err.toString())
              errMsg = "";
              try {
                errMsg = JSON.parse(err);
                if(errMsg.length == 1){
                  errMsg = errMsg[0];
                }
              } catch{
                errMsg = err.toString();
              }
              concatErrors.push(errMsg)
              //mak sure that the errors are directly in err as a string and push to concatErrors
              return tclAPI.concatOlb(concatParams.sourceFolderPath,concatParams.targetOlbFilePath);
            } */// actually lets break at first error, because it wont change anything if we sync partially
          );
        }
        chainedConcatPromises = chainedConcatPromises.then(
          function() {
            return $.Deferred().resolve({status:"OK",inputData:concatErrors}).promise();
          },
          function(err) {
            console.log('olb concat error: '+err.toString())
            let errMsg = "";
            try {
              errMsg = JSON.parse(err);
              if(errMsg.length == 1){
                errMsg = errMsg[0];
              }
            } catch(eo){
              errMsg = err.toString();
            }
            concatErrors.push(errMsg)
            
          } // actually lets break at first error, because it wont change anything if we sync partially
        );
        chainedConcatPromises = chainedConcatPromises.then(
          function(){tclAPI.refreshSymbolInfo()}
        );
        return chainedConcatPromises.then(
          function(){
            //return agentAPI.mergeConcatinatedOlbs();
            inputData.response = {concatResults:concatErrors};
            return $.Deferred().resolve(inputData).promise();
          },
          function(){
            //return agentAPI.mergeConcatinatedOlbs();
            inputData.parameters = null;
            inputData.response = {concatResults:concatErrors};
            return $.Deferred().resolve(inputData).promise();
          }
        );

      } else {
        console.log('not in the plugin, we should notify the user somehow to open plugin to finish synchronization');
        console.log('maybe by setting some flag on the vue store that will cause visibility on some kind of notification');
      }
    } 
  
  return $.Deferred().resolve(data).promise();
}

function EventsRpcHandler(data) {
  //console.log('rpc delegate called');
  //console.log(data);
  
    let libraryProgress = data.parameters;
    
  

    store.dispatch('lm_setLibStatuses', libraryProgress)
  // do the necessary update on vue store or wathever

  return $.Deferred().resolve(data).promise();
}
//ACTIONS##################################################################################################################

//Overall

export const goTo = ({commit}, obj) => {

  commit('GOTO', obj);

}

export const setAuthorityToChange = ({commit}, value) => {

  commit('SETAUTHORITYTOCHANGE', value);

}

export const checkIfPlugin = ({commit}, val) => {

  commit('CHECKIFPLUGIN', val);

}
export const checkIfAgent = ({commit}, val) => {

  commit('CHECKIFAGENT', val);

}

export const showLoader = ({commit}, obj) => {

  commit('SHOWLOADER', obj);

}

export const showAlert = ({commit}, obj) => {

  commit('SHOWALERT', obj);

}

export const hideAlert = ({commit}) => {

  commit('HIDEALERT');

}

export const showModalComponent = ({ commit }, obj) => {

  commit("SHOWMODALCOMPONENT", obj);
};

export const hideModalComponent = ({ commit }) => {
  commit("HIDEMODALCOMPONENT");
};

export const showModalSearchPartsComponent = ({ commit }, obj) => {

  commit("SHOWMODALSEARCHPARTSCOMPONENT", obj);
};

export const hideModalSearchPartsComponent = ({ commit }) => {
  commit("HIDEMODALSEARCHPARTSCOMPONENT");
};

export const displayFooterAlert = ({ commit }, obj) => {
  
  commit("SETALERTCONTAINER", obj);
};

export const showSettings = ({commit}) => {

  commit('SHOWSETTINGS');

}

export const hideSettings = ({commit}) => {

  commit('HIDESETTINGS');

}



export const setAlert = ({commit}, obj) => {
  

  return swaggerClient
  .then(function(client){
    

    commit('SETALERT', obj);

    
    let value = "\"type: " + obj.type + " message: " + obj.message + " user: " + obj.user + "\"";
    
   
    return client.Common.Diagnostic.SetAlert(
      {},
      {
        requestBody: value
      }
      )
    .then(function(result) {
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;
    }, function (reason) {
      console.log("init then setAlert error");
      console.log(reason);
      
    });
  })

}
export const getNotifications = ({commit}) => {
  console.log("getNotifications")



  swaggerClient
  .then(function(client){

    client.Common.Diagnostic.GetNotifications()
    .then(function(result) {
      console.log("then getNotifications ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      if(checkConnection(result)){

        commit('GETNOTIFICATIONS', result.obj.data);
      };




    }, function (reason) {
      console.log("init then getNotifications error");
      console.log(reason);
      //this.$store.dispatch('setAlert', {where:"getNotifications2", what:reason});
    });
  })


}

export const setRouting = ({commit}, value) => {

  commit('SETROUTING', value);


}
export const setView = ({commit}, value) => {

  commit('SETVIEW', value);


}
export const setSectionPrefix = ({commit}, value) => {

  commit('SETSECTIONPREFIX', value);


}

//All#####################################################################################

export const setUserFullName = ({commit}, value) => {

  commit('SETUSERFULLNAME', value);

}
export const selectTreeItem = ({commit}, value) => {

  commit('SELECTTREEITEM', value);

}

export const selectTreeItemObject = ({ commit }, value) => {
  commit("SELECTTREEITEMOBJECT", value);
};

export const reloadAfterDeleteTreeItem = ({ commit }, value) => {
  commit("RELOADAFTERDELETETREEITEM", value);
};

export const selectSearchPartsTreeItem = ({commit}, value) => {

  commit('SELECTSEARCHPARTSTREEITEM', value);

}

export const selectSearchPartsTreeItemObject = ({ commit }, value) => {
  commit("SELECTSEARCHPARTSTREEITEMOBJECT", value);
};

export const setElementCategory = ({commit}, value) => {

  commit('SETELEMENTCATEGORY', value);

}

export const setSearchPartsElementCategory = ({commit}, value) => {

  commit('SETSEARCHPARTSELEMENTCATEGORY', value);

}

export const setSelectedRows = ({commit}, arr) => {

  commit('SETSELECTEDROWS', arr);
  
  commit('UNSELECTALTERNATIVE');

}

export const setOneSelectedRows = ({commit}, arr) => {

  commit('SETONESELECTEDROWS', arr);
  
  commit('UNSELECTALTERNATIVE');

}

export const deleteSelectedRows = ({commit}, value) => {

  commit('DELETESELECTEDROWS', value);
  commit('UNSELECTALTERNATIVE');

}

export const deleteAllSelectedRows = ({commit}) => {

  commit('DELETEALLSELECTEDROWS');
  commit('UNSELECTALTERNATIVE');

}

export const setSaveStatus = ({commit}, value) => {

  commit('SETSAVESTATUS', value);
  

}

export const setSelectedRowsSearch = ({commit}, value) => {

  commit('SETSELECTEDROWSSEARCH', value);

}

export const deleteSelectedRowsSearch = ({commit}, value) => {

  commit('DELETESELECTEDROWSSEARCH', value);

}

export const deleteAllSelectedRowsSearch = ({commit}) => {

  commit('DELETEALLSELECTEDROWSSEARCH');

}

export const selectRevisionRow = ({commit}, obj) => {



  commit('SELECTREVISIONROW', obj);

}

export const deselectRevisionRow = ({commit}, obj) => {

  commit('DESELECTREVISIONROW', obj);

}

export const deselectAllRevisionRow = ({commit}) => {

  commit('DESELECTALLREVISIONROW');

}

export const selectFormRow = ({commit}, value) => {

  commit('SELECTFORMROW', value);

}

export const deselectFormRow = ({commit}, value) => {

  commit('DESELECTFORMROW', value);

}

export const deselectAllFormRow = ({commit}) => {

  commit('DESELECTALLFORMROW');

}

export const setFormTableInstance = ({commit}, value) => {

  commit('SETFORMTABLEINSTANCE', value);
}

export const selectIndexFormRow = ({commit}, value) => {

  commit('SELECTINDEXFORMROW', value);

}

export const deleteIndexFormRow = ({commit}) => {

  commit('DELETEINDEXFORMROW');

}

export const setterFormDetailsData = ({commit}, obj) => {

  commit('SETTERFORMDETAILSDATA', obj);
}

export const setFormProperty = ({commit}, value) => {

  commit('SETFORMPROPERTY', value);
}

export const setPartRevisionId = ({commit}, value) => {

  commit('SETPARTREVISIONID', value);
}

export const setSearchingObject = ({commit}, value) => {

  commit('SETSEARCHINGOBJECT', value);
}

export const deleteProcessId = ({commit}) => {

  commit('DELETEPROCESSID');
}

export const setProcessId = ({commit}, value) => {

  commit('SETPROCESSID', value);
}

export const setCategoryMapping = ({commit}, obj) => {

  commit('SETCATEGORYMAPPING', obj)
}

export const deleteCategoryMapping = ({commit}) => {

  commit('DELETECATEGORYMAPPING')
}

export const setFilteredData = ({commit}, value) => {

  commit('SETFILTEREDDATA', value)
}

export const setPropertyId = ({commit}, value) => {

  commit('SETPROPERTYID', value);
}

export const reloadAfterAction = ({commit}, obj) => {

  commit('RELOADAFTERACTION', obj);
}

export const reloadAfterActionComplex = ({commit}, obj) => {

  commit('RELOADAFTERACTIONCOMPLEX', obj);
}

export const createPropertyForm = ({commit}, obj) => {
  commit('CREATEPROPERTYFORM', obj);
}

export const editPropertiesForm = ({commit}, value) => {
 
  commit('EDITPROPERTIESFORM', value);
}

export const addPropertyToSaving = ({commit}, obj) => {
  commit('ADDPROPERTYTOSAVING', obj);
}

export const addLibraryFilesToSaving = ({commit}, obj) => {
  commit('ADDLIBRARYFILESTOSAVING', obj);
}

export const resetPropertyToSaving = ({commit}) => {
  commit('RESETPROPERTYTOSAVING')
}

export const resetLibraryFilesToSaving = ({commit}) => {
  commit('RESETLIBRARYFILESTOSAVING')
}

//S - settings #########################################################################

export const changeSkinVariant = ({commit}, value) => {

   commit('S_CHANGESKINVARIANTS', value);

}

export const setGlobalSettings = ({}, obj) => {


  return swaggerClient
  .then(function(client){

  return  client.PartManagement.Settings.SetGlobalSettings(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then setGlobalSettings ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then setGlobalSettings error");
      console.log(reason);

    });
  })

}

export const getGlobalSettings = ({commit}) => {

  swaggerClient
  .then(function(client){

    client.PartManagement.Settings.GetGlobalSettings()
    .then(function(result) {
      console.log("then getGlobalSettings ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      if (result.obj.status == "OK") {
        
        
        commit('S_GLOBALSETTINGS', result.obj.data)

      }

    }, function (reason) {
      console.log("then getGlobalSettings error");
      console.log(reason);

    });
  })

}

export const getSettings = ({commit}) => {


  swaggerClient
  .then(function(client){

    client.PartManagement.Settings.GetSettings()
    .then(function(result) {
      console.log("then getSettings ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      if (result.obj.status == "OK"){
        if (result.obj.data.settingsDto == undefined){
          commit('S_CHANGESKINVARIANTS', "dark");
        }else{
          commit('S_CHANGESKINVARIANTS', result.obj.data.settingsDto.Theme);
        }
        
        
        commit('S_LIC', result.obj.data.licenseEntity);
        // let obj = {
        //   build: result.obj.data.build,
        //   buildAgentUpdate: result.obj.data.buildAgentUpdate
        // }
        // commit('S_BUILD', obj);
        
        
      }else{
        commit('S_CHANGESKINVARIANTS', "dark");
      }

    }, function (reason) {
      console.log("init then getSettings error");
      console.log(reason);

    });
  })

}

export const getAgentInfo = ({ }) => {

  
  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.GetAgentInfo()
      .then(function (result) {
        console.log("then getAgentInfo ok");

        if (result.obj.status == "ERROR") {
          checkReason(result);
        }

        return result.obj;

      }, function (reason) {
        console.log("init then getAgentInfo error");
        console.log(reason);

      });
  })

}

export const setTheme = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.SetTheme(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then setTheme ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("init then setTheme error");
      console.log(reason);

    });
  })

}

export const setLanguage = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.SetLanguage(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then setLanguage ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("init then setLanguage error");
      console.log(reason);

    });
  })

}

export const updateSearchEngine = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.UpdateSearchEngine(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then updateSearchEngine ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("init then updateSearchEngine error");
      console.log(reason);

    });
  })

}

export const getSearchEngines = ({}) => {


  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.GetSearchEngines()
    .then(function(result) {
      console.log("then getSearchEngines ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("init then getSearchEngines error");
      console.log(reason);

    });
  })

}

export const getSearchEngine = ({}, obj) => {




  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.GetSearchEngine(obj)
    .then(function(result) {
      console.log("then getSearchEngine ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("init then getSearchEngine error");
      console.log(reason);

    });
  })

}

export const getSearchEnginesBasic = ({}) => {




  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.GetSearchEnginesBasic()
    .then(function(result) {
      console.log("then getSearchEnginesBasic ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("init then getSearchEnginesBasic error");
      console.log(reason);

    });
  })

}

export const setOuterData = ({commit}, value) => {

  commit('SETOUTERDATA', value);


}

export const cleanDatabase = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.DatabaseCleaning()
    .then(function(result) {
      console.log("then cleanDatabase ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("init then cleanDatabase error");
      console.log(reason);

    });
  })


}

export const restoreDatabase = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.PartManagement.Settings.DatabaseRestore()
    .then(function(result) {
      console.log("then restoreDatabase ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("init then restoreDatabase error");
      console.log(reason);

    });
  })


}

export const setNewSubCategory = ({commit}, value) => {

  commit('SETNEWSUBCATEGORY', value);


}

export const s_checkAgentVersion = ({  }) => {
  
  
  return agentAPI.checkAgentVersion()
    .then(function (result) {
      
      return result;

    })
    .then(null, agentAPI.wrapOutErrorPromise);
  
  
  
}

export const s_getAgentUpdate = ({}) => {

    return swaggerClient
      .then(function (client) {
      
                    

      return client.PartManagement.Settings.GetAgentUpdate()
      .then(function(result) {
                
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
               
        
        return result.data
  
  
      }, function (reason) {
        console.log("then s_getAgentUpdate error");
        console.log(reason);
        
      });
    })
  
}
  
export const s_uploadLicence = ({commit}, obj) => {


  return swaggerClientFile
  .then(function(client){

    return client.PartManagement.Settings.UploadLicence(
      {
        
      },
      {
        requestBody: obj.file
      }
    )
    .then(function(result) {
      console.log("then s_uploadLicence ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      
      console.warn("s_uploadLicence " + reason);
                
      commit("SETALERTCONTAINER", { text: "Error. " + reason, time: 15, type: "danger" });
      
    });
  })

}

//externalsuppliers ##########################################################################


export const digiKeyAuthenticate = ({}) => {
  

  return swaggerClient
  .then(function(client){

    return client.PartManagement.ExternalSupplierSynchronization.DigiKeyAuthenticate()
    .then(function(result) {
      console.log("then digiKeyAuthenticate ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("init then digiKeyAuthenticate error");
      console.log(reason);

    });
  })

}

export const approveToken = ({}, obj) => {
  

  return swaggerClient
  .then(function(client){

    return client.PartManagement.ExternalSupplierSynchronization.ApproveToken(obj)
    .then(function(result) {
      console.log("then approveToken ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("init then approveToken error");
      console.log(reason);

    });
  })

}

export const transferOwnershipForm = ({commit}, obj) => {

  commit("TRANSFEROWNERSHIP", obj);
}


//U - Users #############################################################################
export const whoAmI = ({}) => {
  

  return swaggerClient
  .then(function(client){

    return client.PartManagement.Auth.WhoAmI()
    .then(function(result) {
      console.log("then whoAmI ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("whoAmI error");
      console.log(reason);

    });
  })


}
export const login = ({}, credential) => {


  return swaggerClient
  .then(function(client){

    return client.PartManagement.Auth.Login(
      {},
      {
        requestBody: credential
      }
    )
    .then(function(result) {
      console.log("then login ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;

    }, function (reason) {
      console.log("login error");
      console.log(reason);

    });
  })


}

export const setCurrentUser = ({commit}, obj) => {

  commit('SETCURRENTUSER', obj);
}

export const loginConfirm = ({commit}) => {

  commit('LOGIN');

}

export const logout = ({commit}) => {
 


  // let obj = {
  //   login: store.getters.currentUser.login,
  //   token: localStorage.getItem('token')
  // }

  swaggerClient
  .then(function(client){

      client.PartManagement.Auth.Logout()
    .then(function(result) {
      console.log("then logout ok");


      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('role');
      localStorage.removeItem('userId');
      commit('LOGOUT');

      
      router.push({path: '/login'});

    }, function (reason) {
      console.log("then logout error");
      console.log(reason);

    });
  })




}



export const selectUser = ({commit}, obj) => {

  commit('SELECTUSER', obj);
}

export const u_createUserForm = ({commit}, obj) => {

  commit("CREATEUSERFORM", obj);

}

export const u_getUsers = ({ }) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.GetUsers()
    .then(
      result => {
        console.log(" set_getUsers....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error set_getUsers");
      }
    );
  });
};

export const u_getUser = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.GetUser(obj)
    .then(
      result => {
        console.log("ok u_getUser");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error set_getUser");
      }
    );
  });
};

export const u_createUser = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.CreateUser(
      { },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
        console.log(" set_createUser....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function(reason) {
        console.log("error set_createUser");
        console.log(reason);

      }
    );
  });
};

export const u_updateUser = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.UpdateUser(
      { },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
        console.log(" set_updateUser....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },function(reason) {
        console.log("error set_updateUser");
        console.log(reason);

      }
    );
  });
};

export const u_updateUserExt = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.UpdateUserExt(
      { },
      {
        requestBody: obj
      }
    )
    .then(function(result) {

        console.log(" set_updateUserExt....");

        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },function(reason) {

        console.log("error set_updateUserExt");

        console.log(reason);

      }
    );
  });
};

// export const u_deleteUser = ({  }, obj) => {


//   return swaggerClient.then(client => {

//     return client.PartManagement.Auth.DeleteUser({userId:obj.userId})
//     .then(function(result) {
//         console.log(" u_deleteUser....");
//         if (result.obj.status == "ERROR"){
//           checkReason(result);
//         }

//         return result.obj;
//       },function(reason) {
//         console.log(reason);
//         console.log("error u_deleteUser");
//       }
//     );
//   });
// };

export const u_updatePassword = ({  }, obj) => {
  
  return swaggerClient.then(client => {
    return client.PartManagement.Auth.UpdatePassword(
      {
        // login: obj.login,
        // oldPassword: obj.oldPassword,
        // newPassword: obj.newPassword
      },
      {
        requestBody: obj
      }
    )
    .then(
      result => {
        console.log(" u_updatePassword....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log("error u_updatePassword");
        console.log(reason);

      }
    );
  });
};

export const u_changePassword = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Auth.ChangePassword(
      {},
      {
        requestBody: obj
      }
    )
    .then(
      result => {
        console.log(" u_changePassword ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log("error u_changePassword");
        console.log(reason);

      }
    );
  });
};

export const getFullName = ({  }, obj ) => {
  
  return swaggerClient.then(function(client){
    return client.PartManagement.Auth.GetFullName(obj)
    .then(function(result) {
        console.log("then getFullName ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then getFullName error");
      }
    );
    

    
  });
};

export const u_getUsersBasic = ({  }) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.GetUsersBasic()
    .then(
      result => {
        console.log("u_getUsersBasic ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_getUsersBasic");
      }
    );
  });
};

//permissions



export const u_createGroup = ({ }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.CreateGroup(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(result => {
        console.log("u_createGroup ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_createGroup");
      }
    );
  });
};

export const u_updateGroup = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.UpdateGroup(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(
      result => {
        console.log("u_updateGroup ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_updateGroup");
      }
    );
  });
};

export const u_deleteGroup = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.DeleteGroup(obj)
    .then(
      result => {
        console.log("u_deleteGroup ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_deleteGroup");
      }
    );
  });
};

export const u_getGroups = ({  }) => {

  
  return swaggerClient.then(client => {
    return client.PartManagement.Auth.GetGroups()
    .then(
      result => {
        console.log("u_getGroups ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_getGroups");
      }
    );
  });
};

export const u_getPermissions = ({ }) => {
  
  let data = [
      {
        name: "Library category",
        permissionId: -100001
      },
      
      ]
let d = {}
  d.data = data
  d.status = "OK"
      return d


  return swaggerClient.then(client => {
    return client.PartManagement.Auth.GetPermissions()
    .then(
      result => {
        console.log("u_getPermissions ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_getPermissions");
      }
    );
  });
};

// export const u_assignUserToGroup = ({ }, obj) => {
  
//   console.log(obj)
//   return swaggerClient.then(client => {
//     return client.PartManagement.Auth.AssignUserToGroup()
//     .then(
//       result => {
//         console.log("u_assignPermissionToGroup ok");
//         if (result.obj.status == "ERROR"){
//           checkReason(result);
//         }

//         return result.obj;
//       },
//       reason => {
//         console.log(reason);
//         console.log("error u_assignPermissionToGroup");
//       }
//     );
//   });
// };

export const u_assignItemToGroup = ({ },obj) => {
  
  console.log(obj)
  return swaggerClient.then(client => {
    return client.PartManagement.Auth.AssignItemToGroup(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(
      result => {
        console.log("u_assignItemToGroup ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error u_assignItemToGroup");
      }
    );
  });
};

//D - Dashboard #############################################################################

export const d_getActiveParts = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetActiveParts()
    .then(function(result) {
      console.log("then d_getActiveParts ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj
      

    }, function (reason) {
      console.log("init then d_getActiveParts error");
      console.log(reason);
      
    });
  })


}

export const d_getPendingParts = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetPendingParts()
    .then(function(result) {
      console.log("then d_getPendingParts ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj
      

    }, function (reason) {
      console.log("init then d_getPendingParts error");
      console.log(reason);
      
    });
  })


}

export const d_getActiveLibraries = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetActiveLibraries()
    .then(function(result) {
      console.log("then d_getActiveLibraries ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj
      

    }, function (reason) {
      console.log("init then d_getActiveLibraries error");
      console.log(reason);
      
    });
  })


}

export const d_getPendingLibraries = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetPendingLibraries()
    .then(function(result) {
      console.log("then d_getPendingLibraries ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj
      

    }, function (reason) {
      console.log("init then d_getPendingLibraries error");
      console.log(reason);
      
    });
  })


}

export const d_getROHSCompliant = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetROHSCompliant()
    .then(function(result) {
      console.log("then d_getROHSCompliant ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj
      

    }, function (reason) {
      console.log("init then d_getROHSCompliant error");
      console.log(reason);
      
    });
  })


}

export const d_getMyTasks = ({}) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetMyTasks()
    .then(function(result) {
      console.log("then d_getMyTasks ok");
      
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj
      

    }, function (reason, er) {
      console.log("init then d_getMyTasks error");
      console.log(reason);
      
    })
    
  })


}



export const d_getEndOfParts = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.Dashboard.Widgets.GetEndOfPart(obj)
    .then(function(result) {
      console.log("then d_getEndOfParts ok");
      
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj
      

    }, function (reason, er) {
      console.log("init then d_getEndOfParts error");
      console.log(reason);
      
    })
    
  })


}


export const d_getWidgets = ({commit}) => {


  swaggerClient
  .then(function(client){

    client.Dashboard.Widgets.GetWidgets()
    .then(function(result) {
      console.log("then d_getWidgets ok");


      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      commit('D_GETDASHBOARDWIDGETS', result.obj.data);

    }, function (reason) {
      console.log("init then d_getWidgets error");
      console.log(reason);
      
    });
  })


}

export const d_setFilteredData = ({commit}, value) => {

      commit('D_SETFILTEREDDATA', value);


}

export const d_setWidgetsSettings = ({commit}, obj) => {

  commit('D_SETWIDGETSSETTINGS', obj);


}

//PM - Part Manager #############################################################################

export const pm_addActiveFilter = ({commit}, value) => {

  commit('PM_ADDACTIVEFILTER', value);

}

export const pm_deleteActiveFilter = ({commit}, value) => {

  commit('PM_DELETEACTIVEFILTER', value);

}

export const pm_deleteAllActiveFilters = ({commit}) => {

  commit('PM_DELETEALLACTIVEFILTERS');

}

export const pm_addActiveAction = ({commit}, obj) => {

  commit('PM_ADDACTIVEACTION', obj);

}

export const pm_deleteActiveAction = ({commit}, obj) => {

  commit('PM_DELETEACTIVEACTION', obj);

}

export const pm_deleteAllActiveActions = ({commit}) => {

  commit('PM_DELETEALLACTIVEACTIONS');

}

export const pm_getCategories = ({commit}) => {



  swaggerClient
  .then(function(client){

    client.PartManagement.Parts.GetTree()
    .then(function(result) {
      console.log("then pm_getCategories ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      commit('GETDATATREE', result.obj.data);
      
      
      // if (store.getters.selectedTreeItemObject == ""){
      //   const obj = result.obj.data;
      //   obj.children = [];

      //   commit("SELECTTREEITEMOBJECT", obj);
      // }
      let commitType = "SELECTTREEITEMOBJECT";

      if (store.getters.selectedTreeItemObject.categoryId == undefined) {
        selectCategoryChecker(result.obj.data, 1, commitType);    
      } else {
        selectCategoryChecker(result.obj.data, store.getters.selectedTreeItemObject.categoryId,commitType);    
      }
      
      
    }, function (reason) {
      console.log(" pm_getCategories error");
      console.log(reason);
      
    });
  })

}

export const pm_getSearchPartsCategories = ({commit}) => {



  swaggerClient
  .then(function(client){

    client.PartManagement.Parts.GetTree()
    .then(function(result) {
      console.log("then getTree ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      commit('GETSEARCHPARTSDATATREE', result.obj.data);
      
      
      if (store.getters.selectedSearchPartsTreeItemObject == ""){
        const obj = result.obj.data;
        obj.children = [];

        commit("SELECTTREEITEMOBJECT", obj);
      }

      
      
    }, function (reason) {
      console.log("init then getData error");
      console.log(reason);
      
    });
  })

}

export const pm_getFlatCategories = ({}) => {



  return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.GetTree()
    .then(function(result) {
      console.log("pm_getCategories ok");

      //commit('GETDATATREE', result.obj.data);
      return result.obj
      
      

    }, function (reason) {
      console.log("pm_getCategories error");
      console.log(reason);
      
    });
  })

}

export const pm_createCategory = ({  }, obj) => {

  //let objAlertSuccess = obj.objAlertSuccess;
  //let objAlertError = obj.objAlertError;

  
  return swaggerClientFile.then(client => {
    return client.PartManagement.Parts.CreateCategory(
      {
        fullPath: obj.fullPath,
        template: obj.template,
        cisCompatible: obj.cisCompatible,
        is4eyesRuleOff: obj.is4eyesRuleOff
      },
      {
        requestBody: {file: obj.file}
      })
    .then(
      result => {
        console.log(" category created....");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        //commit("SETALERTCONTAINER", objAlertSuccess);
        
        return result.obj;
      },
      reason => {
        console.log(reason);
        //commit("SETALERTCONTAINER", objAlertError);
        console.log("error created categories");
      }
    );
  });
};
export const pm_updateCategory = ({  }, obj) => {

  //let objAlertSuccess = obj.objAlertSuccess;
  //let objAlertError = obj.objAlertError;

  
  return swaggerClientFile.then(client => {
    return client.PartManagement.Parts.UpdateCategory(
      {
        fullPath: obj.fullPath,
        categoryId: obj.categoryId,
        template: obj.template,
        cisCompatible: obj.cisCompatible,
        is4eyesRuleOff: obj.is4eyesRuleOff
      },
      {
        requestBody: {file: obj.file}
      })
    .then(
      result => {
        console.log("pm_updateCategory ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        //commit("SETALERTCONTAINER", objAlertSuccess);
        return result.obj;
      },
      reason => {
        console.log(reason);
        //commit("SETALERTCONTAINER", objAlertError);
        console.log("error pm_updateCategory");
      }
    );
  });
};
export const pm_deleteCategory = ({ commit }, obj ) => {
  
  let objAlertSuccess = obj.objAlertSuccess;
  let objAlertError = obj.objAlertError;

  return swaggerClient.then(function(client){
    return client.PartManagement.Parts.DeleteCategory({categoryId: obj.categoryId})
    .then(function(result) {
        console.log(" category deleted....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        if (result.obj.data == 1){
          commit("SETALERTCONTAINER", objAlertSuccess);
        }else{
          commit("SETALERTCONTAINER", objAlertError);

        }

        //return result;
      }, function (reason) {
        console.log(reason);
        commit("SETALERTCONTAINER", objAlertError);
        console.log("error deleted caegories");
      }
    );
  });
};

export const pm_checkIfPartsInCategory  = ({  }, obj) => {
 
  return swaggerClient.then(function(client) {
    return client.PartManagement.Parts.CheckIfPartsInCategory (obj).then(
      function(result) {
        console.log("then pm_checkIfPartsInCategory ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      function(reason) {
        console.log("init then pm_checkIfPartsInCategory error");
        console.log(reason);
        
      }
    );
  });
};

export const pm_setExistingTypes = ({ commit }, arr) => {

  commit("SETEXISTINGTYPES", arr);
}

export const pm_getProperties = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetProperties(obj)
    .then(
      result => {
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error created caegories");
      }
    );
  });
};



export const pm_createProperty = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.PartManagement.Parts.CreateProperty(
      { categoryId: obj.categoryId},
      {
        requestBody: {
          propertyId: 0,
          name: obj.name,
          type: obj.type,
          isRequiredOnRequest: obj.isRequiredOnRequest,
          isRequiredOnRelease: obj.isRequiredOnRelease,
          isRevisionChanging: obj.isRevisionChanging,
          isSearchString: obj.isSearchString,
          cisBrowsable: obj.cisBrowsable,
          cisDesignation: obj.cisDesignation,
          hdlDesignation: obj.hdlDesignation,
          libraryCategoryId: obj.libraryCategoryId
        }
      }
    )
    .then(
      result => {
        console.log("ok pm_createProperty");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log("error pm_createProperty");
        console.log(reason);

      }
    );
  });
};

export const pm_updateProperty = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Parts.UpdateProperty(
      { categoryId: obj.categoryId},
      {
        requestBody: {
          propertyId:obj.propertyId,
          name: obj.name,
          type: obj.type,
          isRequiredOnRequest: obj.isRequiredOnRequest,
          isRequiredOnRelease: obj.isRequiredOnRelease,
          isRevisionChanging: obj.isRevisionChanging,
          isSearchString: obj.isSearchString,
          cisDesignation: obj.cisDesignation, 
          cisBrowsable: obj.cisBrowsable,
          hdlDesignation: obj.hdlDesignation, 
          maxLength: obj.maxLength,
          libraryCategoryId: obj.libraryCategoryId
        }
      })
    .then(
      result => {
        console.log(" UpdateProperty....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error UpdateProperty");
      }
    );
  });
};

export const pm_deleteProperty = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Parts.DeleteProperty(obj)
    .then(
      result => {
        console.log(" DeleteProperty....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error DeleteProperty");
      }
    );
  });
};

export const pm_getPropertiesType = ({  }) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetPropertiesType()
    .then(
      result => {
        console.log(" GetPropertiesType....");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error GetPropertiesType");
      }
    );
  });
};


export const pm_createNewPart = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Parts.CreateNewPart(
      { 
        categoryId: obj.categoryId,
        distributorPartId: obj.distributorPartId,
      },
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log(" CreateNewPart....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error CreateNewPart");
      }
    );
  });
};

export const pm_createNewPartValidation = ({  }, arr) => {



  return swaggerClient.then(client => {
    return client.PartManagement.Parts.CreateNewPartValidation(
      { 
        
      },
      {
        requestBody: arr
      })
    .then(
      result => {
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_createNewPartValidation");
      }
    );
  });
};

export const pm_updatePart = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.PartManagement.Parts.UpdatePart(
      { revisionId: obj.revisionId},
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log(" UpdatePart....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error UpdatePart");
      }
    );
  });
};

export const pm_updatePartValidation = ({  }, arr) => {



  return swaggerClient.then(client => {
    return client.PartManagement.Parts.UpdatePartValidation(
      { 
        
      },
      {
        requestBody: arr
      })
    .then(
      result => {
        console.log("pm_updatePartValidation ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_updatePartValidation");
      }
    );
  });
};

export const pm_createNewPropertyFromFound = ({  }, obj) => {


  return swaggerClient.then(client => {
    return client.PartManagement.Parts.CreateNewPropertyFromFound(
      { 
        categoryId: obj.categoryId,
        partRevisionId: obj.revisionId
      },
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log("ok pm_createNewPart....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_createNewPart");
      }
    );
  });
};

export const pm_getActions = ({}) => {

return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.GetActions()
    .then(function(result) {
      console.log("then pm_getActions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      
      return result.obj;

    }, function (reason) {
      console.log("init then pm_getActions error");
      console.log(reason);
      
    });
  })

}

export const pm_getFormDetails = ({commit}, obj) => {
  
  swaggerClient
  .then(function(client){


    client.PartManagement.Parts.GetFormDetails({category:obj.category, keys:obj.keys})
    .then(function(result) {
      console.log("then pm_getFormDetails ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      commit('GETFORMDETAILS', result.obj.data);

    }, function (reason) {
      console.log("init then pm_getFormDetails error");
      console.log(reason);
      
    });
  })


}

export const pm_getNewFormDetails = ({commit}, value) => {

  swaggerClient
  .then(function(client){


    client.PartManagement.Parts.GetNewFormDetails({category: value})
    .then(function(result) {
      console.log("then pm_getNewFormDetails ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      commit('GETFORMDETAILS', result.obj.data);

    }, function (reason) {
      console.log("init then pm_getNewFormDetails error");
      console.log(reason);
      
    });
  })


}

export const pm_getQuickView = ({}, obj) => {

  return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetQuickView(
        {
          partRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then pm_getQuickView ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revision = obj.revision;
        return result.obj

      }, function (reason) {
        console.log("init then pm_getQuickView error");
        console.log(reason);
        
      });
    })

  }

  export const getAssemblyElements = ({}, obj) => {
    return swaggerClient
    .then(function(client){


      let revision = obj.revision;
      return client.PartManagement.Parts.GetAssemblyElements(obj)
      .then(function(result) {
        console.log("then getAssemblyElements ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        if (revision != undefined){
          result.obj.revision = revision;
        }
        
                
        return result.obj

      }, function (reason) {
        console.log("init then getAssemblyElements error");
        console.log(reason);
        
      });
    })
  
  }

  

export const pm_getPart = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPart(
        {
          partRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then pm_getPart ok");
        if (result.obj.status == "ERROR") {
          
          checkReason(result);
        }
        
        result.obj.revisionId = obj.revisionId;
        result.obj.revision = obj.revision;
        
        return result.obj

      }, function (reason) {
        console.log("init then pm_getPart error");
        console.log(reason);
        
      });
    })

  }  

export const pm_getRevisionHistory = ({commit}, value) => {

  
  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetRevisionHistory({partId: value})
    .then(function(result) {
      console.log("then pm_getRevisionHistory ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      commit('GETREVISIONHISTORY', result.obj.data);

      return result.obj;

    }, function (reason) {
      console.log("init then pm_getRevisionHistory error");
      console.log(reason);
      
    });
  })


}

export const pm_bulkSetWithdraw = ({ }, obj) => {
  
 
  return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.BulkSetWithdraw(
        { 
          
        },
        {
          requestBody: obj.partIds
        })
      .then(function(result) {
        console.log("then pm_bulkSetWithdraw ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
        

      }, function (reason) {
        console.log("init then pm_bulkSetWithdraw error");
        console.log(reason);
        
      });
    })

  }
export const pm_bulkDeletePart = ({ }, obj) => {
  
  
  
  return swaggerClient
    .then(client => {

    return client.PartManagement.Parts.BulkDeletePart(
      {

      },
      {
        requestBody: obj.partIds
      })
    .then(
      result => {
        console.log(" pm_bulkDeletePart ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_bulkDeletePart");
      }
    );
  })
  .catch((reason) => {
    console.warn(reason);
    return reason
  })
};

export const pm_executeExternalSearch = ({}, obj) => {

  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.ExecuteExternalSearch(obj)
    .then(function(result) {
      console.log("then pm_executeExternalSearch ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return JSON.parse(result.data);

    }, function (reason) {
      console.log("init then pm_executeExternalSearch error");
      console.log(reason);
      
    });
  })


}
export const pm_getSearchedParts = ({}, obj) => {


  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetSearchedParts(obj)
    .then(function(result) {
      console.log("then pm_getSearchedParts ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("init then pm_getSearchedParts error");
      console.log(reason);
      
    });
  })


}

export const pm_getPhysicalHandmadeParts = ({}) => {


  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetPhysicalHandmadeParts()
    .then(function(result) {
      console.log("then pm_getPhysicalHandmadeParts ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("init then pm_getPhysicalHandmadeParts error");
      console.log(reason);
      
    });
  })


}

export const pm_setTabStatus = ({commit}, value) => {

  commit("SETTABSTATUS", value);
}

export const externalSearchResponse = ({commit}, obj) => {
  commit("EXTERNALSEARCHRESPONSE", obj);

}
export const pm_getSearchedPartsDetails = ({}, obj) => {

  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetSearchedPartsDetails(obj)
    .then(function(result) {
      console.log("then pm_getSearchedPartsDetails ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("init then pm_getSearchedPartsDetails error");
      console.log(reason);
      
    });
  })


}

export const pm_getSEDetailsByKey = ({}, obj) => {

  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetSEDetailsByKey(obj)
    .then(function(result) {
      console.log("then pm_getSEDetails ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("then pm_getSEDetails error");
      console.log(reason);
      
    });
  })


}

export const pm_getSEDetailsByMPN = ({}, obj) => {
return {data: 1}
  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetSEDetailsByMPN(obj)
    .then(function(result) {
      console.log("then pm_getSEDetailsByMPN ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("then pm_getSEDetailsByMPN error");
      console.log(reason);
      
    });
  })


}

export const setSelectedSearchedRows = ({commit}, obj) => {
  commit('SETSELECTEDSEARCHEDROWS', obj);
}
export const deleteSelectedSearchedRows = ({commit}) => {
  commit('DELETESELECTEDSEARCHEDROWS');
}
export const pm_getSearchHistory = ({}, obj) => {

  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetSearchHistory(obj)
    .then(function(result) {
      console.log("then pm_getSearchHistory ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("init then pm_getSearchHistory error");
      console.log(reason);
      
    });
  })


}

export const pm_getPossibleValueForCombo = ({commit}, value) => {

  swaggerClient
    .then(function(client){

      client.PartManagement.Parts.GetPossibleValueForCombo({key:value})
      .then(function(result) {
        console.log("then pm_getPossibleValueForCombo ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        commit('GETPOSSIBLEVALUEFORCOMBO', result.obj.data);

      }, function (reason) {
        console.log("init then pm_getPossibleValueForCombo error");
        console.log(reason);
        
      });
    })

  }
export const pm_saveData = ({}, obj) => {

  return swaggerClient
    .then(function(client){
      return client.PartManagement.Parts.SaveData({obj: obj})
      .then(function(result) {
        console.log("then pm_saveData ok");

        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        try{

          var res = {}

          if (result.obj == undefined){
            
            res.message = ""
            res.ok = true

            return res

          }else{
            
            res.message = result.message
            res.ok = false

            return res
          }


        }catch(e){
          console.log("Error:")
          console.log(e)
        }




      }, function (reason) {
        console.log("init then pm_saveData error");

        console.log(reason.response);

        try{

          var res = {}

          if (reason.response.obj.status == "ERROR"){
            
            res.message = reason.response.obj.message
            res.ok = false

            return res

          }


        }catch(e){
          console.log("Error:")
          console.log(e)
        }




      })


    })

  }


export const pm_validate = ({}, obj) => {



  return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.Validate({key:obj.key, value:obj.value})
    .then(function(result) {
      console.log("then pm_validate ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj.data


    }, function (reason) {
      console.log("init then pm_validate error");
      console.log(reason);
      
    });
  })

}

export const pm_importFileWithParts = ({commit}, obj) => {


  return swaggerClientFile
  .then(function(client){

    return client.PartManagement.Parts.ImportFileWithParts(
      {
        separator: obj.separator
      },
      {
        requestBody: obj.file
      }
    )
    .then(function(result) {
      console.log("then pm_importFileWithParts ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      
      console.warn("pm_importFileWithParts " + reason);
                
      commit("SETALERTCONTAINER", { text: "Error. " + reason, time: 15, type: "danger" });
      
    });
  })

}


export const pm_MappingImportedParts = ({commit}, obj) => {
  
    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.MappingImportedParts(
        {
          categoryId: obj.categoryId, documentId: obj.documentId, allActive: obj.allActive, type: obj.type, separator: obj.separator
        },
        {
          requestBody: obj.mapped
        }
        )
      .then(function(result) {
        console.log("then pm_MappingImportedParts ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj


      }, function (reason) {
        
        console.warn("pm_MappingImportedParts " + reason);
                
        commit("SETALERTCONTAINER", { text: "Error. " + reason, time: 15, type: "danger" });
        
        commit('SHOWLOADER', { visible: false });
      });
    })

  }

  export const pm_ImportingPartByPartType = ({commit}, obj) => {
  
    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.ImportingPartByPartType(
        {
          category: obj.category, documentId: obj.documentId, allActive: obj.allActive, separator: obj.separator
        },
        {
          requestBody: obj.types
        }
        )
      .then(function(result) {
        console.log("then pm_ImportingPartByPartType ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj


      }, function (reason) {
        console.warn("pm_ImportingPartByPartType " + reason);
                
        commit("SETALERTCONTAINER", { text: "Error. " + reason, time: 15, type: "danger" });

        commit('SHOWLOADER', { visible: false });
        
      });
    })

}
  
export const pm_importPartsByCategory = ({commit}, obj) => {
  
    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.ImportPartsByCategory(
        {
          documentId: obj.documentId, allActive: obj.allActive, separator: obj.separator, type: obj.type
        },
        {
          requestBody: obj.mapped
        }
        )
      .then(function(result) {
        console.log("then pm_importPartsByCategory ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj


      }, function (reason) {
        console.warn("pm_importPartsByCategory " + reason);
                
        commit("SETALERTCONTAINER", { text: "Error. " + reason, time: 15, type: "danger" });

        commit('SHOWLOADER', { visible: false });
        
      });
    })

  }

  export const pm_setPreviewParts = ({commit}, obj) => {
    commit('SETPREVIEWPARTS', obj)
  }


  export const pm_setImportedFileId = ({commit}, value) => {
    commit('SETIMPORTEDFILEID', value);
  }

  export const pm_addMapField = ({ commit }, obj) => {
    commit("ADDMAPFIELD", obj);
  };
  
  export const pm_addMapFieldPartType = ({ commit }, obj) => {
    commit("ADDMAPFIELDPARTTYPE", obj);
  };

  export const pm_resetMapField = ({ commit }) => {
    commit("RESETMAPFIELD");
  };

  export const pm_setDerivedNewProps = ({commit}, arr) => {
    commit("SETDERIVEDNEWPROPS", arr);
  }

  export const pm_createFootprint = ({commit}, obj) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.CreateFootprint(obj)
      .then(function(result) {
        console.log("then pm_createFootprint ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_createFootprint error");
        console.log(reason);
        
      });
    })
  
  }
  export const pm_updateFootprint = ({}, obj) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.UpdateFootprint(obj)
      .then(function(result) {
        console.log("then pm_updateFootprint ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_updateFootprint error");
        console.log(reason);
        
      });
    })
  
  }
  export const pm_deleteFootprint = ({}, obj) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.DeleteFootprint(obj)
      .then(function(result) {
        console.log("then pm_deleteFootprint ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_deleteFootprint error");
        console.log(reason);
        
      });
    })
  
  }
  export const pm_getFootprints = ({}) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.GetFootprints()
      .then(function(result) {
        console.log("then pm_getFootprints ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_getFootprints error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_addSelectedFootprint = ({commit}, obj) => {
    
    commit("ADDSELECTEDFOOTPRINTS", obj);
  }

  export const pm_deleteSelectedFootprint = ({commit}) => {
    
    commit("DELETESELECTEDFOOTPRINTS");
  }

  export const pm_createSymbol = ({commit}, obj) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.CreateSymbol(obj)
      .then(function(result) {
        console.log("then pm_createSymbol ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_createSymbol error");
        console.log(reason);
        
      });
    })
  
  }
  export const pm_updateSymbol = ({}, obj) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.UpdateSymbol(obj)
      .then(function(result) {
        console.log("then pm_updateSymbol ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_updateSymbol error");
        console.log(reason);
        
      });
    })
  
  }
  export const pm_deleteSymbol = ({}, obj) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.DeleteSymbol(obj)
      .then(function(result) {
        console.log("then pm_deleteSymbol ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_deleteSymbol error");
        console.log(reason);
        
      });
    })
  
  }
  export const pm_getSymbols = ({}) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.GetSymbols()
      .then(function(result) {
        console.log("then pm_getSymbols ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_getSymbols error");
        console.log(reason);
        
      });
    })
  
}
  
export const pm_getHDLSymbols = ({}) => {

    return swaggerClient
    .then(function(client){
  
      return client.PartManagement.Parts.GetHDLSymbols()
      .then(function(result) {
        console.log("then pm_getHDLSymbols ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_getHDLSymbols error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_addSelectedSymbol = ({commit}, obj) => {
    
    commit("ADDSELECTEDSYMBOLS", obj);
  }

  export const pm_deleteSelectedSymbol = ({commit}, obj) => {
    
    commit("DELETESELECTEDSYMBOLS", obj);
  }

  export const pm_deleteAllSelectedSymbols = ({commit}) => {
    
    commit("DELETEALLSELECTEDSYMBOLS");
  }
  
  export const pm_addSelectedAltSymbol = ({commit}, obj) => {
    
    commit("ADDSELECTEDALTSYMBOLS", obj);
  }

  export const pm_deleteSelectedAltSymbol = ({commit}, obj) => {
    
    commit("DELETESELECTEDALTSYMBOLS", obj);
  }

  export const pm_deleteAllSelectedAltSymbols = ({commit}) => {
    
    commit("DELETEALLSELECTEDALTSYMBOLS");
  }

  export const pm_getTasks = ({commit}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetTasks(obj)
      .then(function(result) {
        console.log("then pm_getTasks ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        if (result.obj.status == "OK") {
          commit("SETSECONDLEVEL", result.obj.data);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("init then pm_getTasks error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_setEventTask = ({}, obj) => {
  
    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.SetEventTask(
        {
          
        },
        {
          requestBody: obj
        }
        )
      .then(function(result) {
        console.log("then pm_setEventTask ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj


      }, function (reason) {
        console.log("init then pm_setEventTask error");
        console.log(reason);
        
      });
    })

  }

  export const pm_setEventTaskForm = ({commit}, obj) => {

    commit("SETEVENTTASKFORM", obj)
  }

  export const pm_whereUse = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.WhereUse(obj)
      .then(function(result) {
        console.log("then pm_whereUse ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_whereUse error");
        console.log(reason);
        
      });
    })
  
}
  

  export const pm_assignPhysicals = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.AssignPhysicals(
        {
          partId: obj.partId
        },
        {
          requestBody: obj.alternatives
        }
      )
      .then(function(result) {
        console.log("then pm_assignPhysicals ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_assignPhysicals error");
        console.log(reason);
        
      });
    })
  
  }

  export const unassignPhysicals = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.UnassignPhysicals(
        {
          partId: obj.partId
        },
        {
          requestBody: obj.alternatives
        }
      )
      .then(function(result) {
        console.log("then unassignPhysicals ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then unassignPhysicals error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_getPhysicals = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPhysicals(obj)
      .then(function(result) {
        console.log("then pm_getPhysicals ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_getPhysicals error");
        console.log(reason);
        
      });
    })
  
}
  export const pm_getPhysicalsAssembly = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPhysicalsAssembly(obj)
      .then(function(result) {
        console.log("then pm_getPhysicalsAssembly ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_getPhysicalsAssembly error");
        console.log(reason);
        
      });
    })
  
  }

  export const getPhysicalDetails = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPhysicalDetails(obj)
      .then(function(result) {
        console.log("then getPhysicalDetails ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then getPhysicalDetails error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_addAlternativePart = ({commit}, obj) => {

    commit("ADDALTERNATIVEPART", obj);
  }
  export const pm_deleteAlternativePart = ({commit}, obj) => {

    commit("DELETEALTERNATIVEPART", obj);
  }
  export const pm_deleteAllAlternativeParts = ({commit}) => {

    commit("DELETEALLALTERNATIVEPART");
  }

  export const selectAlternative = ({commit}, obj) => {

    commit("SELECTALTERNATIVE", obj);
  };

  export const unselectAlternative = ({commit}) => {

    commit("UNSELECTALTERNATIVE");
  };

  export const getImage = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetImage(obj)
      .then(function(result) {
        console.log("then getImage ok");
        
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        return result.data
  
  
      }, function (reason) {
        console.log("then getImage error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_getSvg = ({}, obj) => {

    return swaggerClient
      .then(function (client) {
      
        const objS = {
          type: obj.type,
          name: obj.name,
          //revisionId: obj.revisionId
        }
            

      return client.PartManagement.Parts.GetSvg(objS)
      .then(function(result) {
                
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        
        if (typeof result.data == "object") {
          
          result.data.id = obj.id;
          result.data.noImage = false;

        } else {
          
          result.obj.id = obj.id;       
          result.obj.noImage = true;
          return result.obj;
          
        }
        
        return result.data
  
  
      }, function (reason) {
        console.log("then getSvg error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_uploadSvg = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      const objS = {
        type: obj.type,
        name: obj.name
      }

      return client.PartManagement.Parts.UploadSvg( {
        type: obj.type,
        
      },
      {
        requestBody: {file: obj.file}
      })
      .then(function(result) {
                
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        
        
        return result.data
  
  
      }, function (reason) {
        console.log("then uploadSvg error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_updatePhysicalParam = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.UpdatePhysicalParam(
        {
          distributorPartId: obj.distributorPartId,
          
        },
        {
          requestBody: obj.params
        }
      )
      .then(function(result) {
        console.log("then pm_updatePhysicalParam ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_updatePhysicalParam error");
        console.log(reason);
        
      });
    })
  
  }
  export const getPhysicalParam = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPhysicalParam(obj)
      .then(function(result) {
        console.log("then getPhysicalParam ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then getPhysicalParam error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_setAllActiveImportedParts = ({commit}, obj) => {

    commit("SETALLACTIVEIMPORTEDPARTS", obj);
  };
  
  export const pm_syncDistributorPart = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.SyncDistributorPart(obj)
      .then(function(result) {
        console.log("then pm_syncDistributorPart ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_syncDistributorPart error");
        console.log(reason);
        
      });
    })
  }

  export const pm_getImportedParts = ({}) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetImportedParts()
      .then(function(result) {
        console.log("then pm_getImportedParts ok");

        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        //commit('GETFILTERS', result.obj.data);
        return result.obj;

      }, function (reason) {
        console.log("init then pm_getImportedParts error");
        console.log(reason);
        
      });
    })

  }
  
  export const pm_undoImportedParts = ({commit}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.UndoImportedParts(obj)
      .then(function(result) {
        console.log("then pm_undoImportedParts ok");

        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        return result.obj;

      }, function (reason) {
        
        console.warn("pm_undoImportedParts " + reason);
                
        commit("SETALERTCONTAINER", { text: "Error. " + reason, time: 15, type: "danger" });
        
      });
    })

  }

  export const pm_setNotImportedParts = ({commit}, arr) => {

    commit("SETNOTIMPORTEDPARTS", arr);
  }

  export const setDuplicatePartNumber = ({commit}, value) => {

    commit("SETDUPLICATEPARTNUMBER", value);
  }

  export const setCurrentSymbol = ({commit}, obj) => {

    commit("SETCURRENTSYMBOL", obj);
  };

  export const pm_createNewAssemblyForm = ({commit}, obj) => {

    commit('CREATENEWASSEMBLYFORM', obj);
  }

  export const pm_createAssembly = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.CreateAssembly(
        {
          
        },
        {
          requestBody: obj
        }
      )
      .then(function(result) {
        console.log("then pm_createAssembly ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_createAssembly error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_assignAssembly = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.AssignAssembly(
        {
          
        },
        {
          requestBody: obj
        }
      )
      .then(function(result) {
        console.log("then pm_assignAssembly ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_assignAssembly error");
        console.log(reason);
        
      });
    })
  
}
  
export const pm_unassignAssembly = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.UnassignAssembly(
        {
          
        },
        {
          requestBody: obj
        }
      )
      .then(function(result) {
        console.log("then pm_unassignAssembly ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_unassignAssembly error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_getAssemblies = ({}) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetAssemblies()
      .then(function(result) {
        console.log("then pm_getAssemblies ok");

        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        return result.obj;

      }, function (reason) {
        console.log("init then pm_getAssemblies error");
        console.log(reason);
        
      });
    })

  }

  export const pm_setAssemblyQuantity = ({commit}, value) => {

    commit("SETASSEMBLYQUANTITY", value);
  }

  export const pm_setSelectedAssemblyRow = ({commit}, obj) => {

    commit("SETSELECTEDASSEMBLYROW", obj);
  }

  export const pm_deleteSelectedAssemblyRow = ({commit}) => {

    commit("DELETESELECTEDASSEMBLYROW");
  }

  export const pm_createPhysical = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.CreatePhysical(
        {
          
        },
        {
          requestBody: obj.physical
        }
      )
      .then(function(result) {
        console.log("then pm_createPhysical ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_createPhysical error");
        console.log(reason);
        
      });
    })
  
}
  
export const pm_updatePhysical = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.UpdatePhysical(
        {
          distributorPartId: obj.distributorPartId
        },
        {
          requestBody: obj.physical
        }
      )
      .then(function(result) {
        console.log("then pm_updatePhysical ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_updatePhysical error");
        console.log(reason);
        
      });
    })
  
}
  
export const pm_deletePhysical = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.DeletePhysical(obj)
      .then(function(result) {
        console.log("then pm_deletePhysical ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_deletePhysical error");
        console.log(reason);
        
      });
    })
  
  }

  export const pm_placePart = ({}, obj) => {

    
    let revId = obj.revisionId;
    let symbol = obj.symbol;
    let device = obj.packageDevice;
    let properties = [
      {
          name: obj.partnumber.name,
          value: obj.partnumber.value,
          visibility: obj.partnumber.visibility
      },
      {
          name: "Revision",
          value: obj.revision,
          visibility: "TransferredToDesign" 
      },
      {
          name: "RevDisplayedValue",
          value: "Rev: "+obj.revision,
          visibility: obj.partnumber.visibility /*!!! derived from Part Number in purpose, because it doesn't have its own settings, because it is not a property*/
      },
      {
          name: "PCB Footprint",
          value: obj.footprint.value,
          visibility: obj.footprint.visibility
      },
      {
          name: obj.value.name,
          value: obj.value.value,
          visibility: obj.value.visibility
      }
    ];
    if (obj.value.name !== 'Value') {
      properties.push({
        name: 'Value',
        value: obj.value.value,
        visibility: "TransferredToDesign"
      });
    }
    if (obj.partnumber.name !== 'Part_Number') {
      properties.push({
        name: 'Part_Number',
        value: obj.partnumber.value,
        visibility: "TransferredToDesign"
      });
    }
    for (let index = 0, lei = obj.otherProps.length; index < lei; index++) {
      const element = obj.otherProps[index];
      properties.push({
          name: element.name,
          value: element.value,
          visibility: element.visibility
      });
    }
    
    return tclAPI.placePart(revId, symbol, device, properties)

  }


  export const pm_exposeToCIS = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.ExposeToCIS(obj)
      .then(function(result) {
        console.log(result)
        console.log("then pm_exposeToCIS ok");
        // if (result.obj.status == "ERROR"){
        //   checkReason(result);
        // }
        return result;
  
  
      }, function (reason) {
        console.log("then pm_exposeToCIS error");
        console.log(reason);
        
      });
    })
  
}
export const pm_exposeToHDL = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.ExposeToHDL(obj)
      .then(function(result) {
        console.log(result)
        console.log("then pm_exposeToHDL ok");
        // if (result.obj.status == "ERROR"){
        //   checkReason(result);
        // }
        return result;
  
  
      }, function (reason) {
        console.log("then pm_exposeToHDL error");
        console.log(reason);
        
      });
    })
  
}

export const pm_bulkCheckMovingToAnotherCategory = ({}, obj) => {

  
  return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.BulkCheckMovingToAnotherCategory(
      {},
      {
        requestBody: obj
      })
    .then(function(result) {
      console.log("then pm_BulkCheckMovingToAnotherCategory ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_BulkCheckMovingToAnotherCategory error");
      console.log(reason);

    });
  })

}

export const pm_bulkMoveToAnotherCategory = ({ }, obj) => {
  
   

  return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.BulkMoveToAnotherCategory(
      {},
      {
        requestBody: obj
      })
    .then(function(result) {
      console.log("then pm_bulkMoveToAnotherCategory ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_bulkMoveToAnotherCategory error");
      console.log(reason);

    });
  })

}

export const pm_moving = ({commit}, obj) => {

    commit("MOVING", obj)
}

export const pm_changePropertyPriority = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.ChangePropertyPriority(
        {

        },
        {
          requestBody: obj
        })
    .then(function(result) {
      console.log("then pm_changePropertyPriority ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_changePropertyPriority error");
      console.log(reason);

    });
  })

}

export const pm_transferOfOwnership = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.TransferOfOwnership(obj)
    .then(function(result) {
      console.log("then pm_transferOfOwnership ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_transferOfOwnership error");
      console.log(reason);

    });
  })

}

export const pm_getAutocompleteValues = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.PartManagement.Parts.GetAutocompleteValues(obj)
    .then(function(result) {
      console.log("then pm_getAutocompleteValues ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getAutocompleteValues error");
      console.log(reason);

    });
  })

}

export const pm_bulkRemoveRevision = ({ }, obj) => {
  
    
  
  return swaggerClient
  .then(function(client){

    
    return client.PartManagement.Parts.BulkRemoveRevision(
      {

      },
      {
        requestBody: obj.partRevisionIds
      })
    .then(function(result) {
      console.log("then pm_bulkRemoveRevision ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_bulkRemoveRevision error");
      console.log(reason);

    });
  })

}

export const pm_assemblyQuantityForm = ({commit}, obj) => {

    commit("SETASSEMBLYQUANTITY", obj)
}

export const pm_checkIfLibrariesReady = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.PartManagement.Parts.CheckIfLibrariesReady(obj)
    .then(function(result) {
      console.log("then pm_checkIfLibrariesReady ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_checkIfLibrariesReady error");
      console.log(reason);

    });
  })

}

export const pm_getCategoryByRevisionId = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.PartManagement.Parts.GetCategoryByRevisionId(obj)
    .then(function(result) {
      console.log("then pm_getCategoryByRevisionId ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getCategoryByRevisionId error");
      console.log(reason);

    });
  })

}

export const pm_changeMPNPriority = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.ChangeMPNPriority(
        {

        },
        {
          requestBody: obj
        })
    .then(function(result) {
      console.log("then pm_changeMPNPriority ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_changeMPNPriority error");
      console.log(reason);

    });
  })

}

export const pm_setStatusMPN = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.SetStatusMPN(
        {

        },
        {
          requestBody: obj
        })
    .then(function(result) {
      console.log("then pm_setStatusMPN ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_setStatusMPN error");
      console.log(reason);

    });
  })

}

export const pm_getSuggestionsFromSE = ({}, obj) => {

console.log(obj)
  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.GetSuggestionsFromSE(obj)
    .then(function(result) {
      console.log("then pm_getSuggestionsFromSE ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getSuggestionsFromSE error");
      console.log(reason);

    });
  })

}

export const pm_assignPartSEToMPN = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.AssignPartSEToMPN(obj)
    .then(function(result) {
      console.log("then pm_assignPartSEToMPN ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_assignPartSEToMPN error");
      console.log(reason);

    });
  })

}

export const pm_unassignPartSEToMPN = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.UnassignPartSEToMPN (obj)
    .then(function(result) {
      console.log("then pm_unassignPartSEToMPN ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_unassignPartSEToMPN error");
      console.log(reason);

    });
  })

}

export const pm_syncSE = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.SyncSE (obj)
    .then(function(result) {
      console.log("then pm_syncSE ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_syncSE error");
      console.log(reason);

    });
  })

}

export const pm_getSEDetailsByDPI = ({}, obj) => {


  return swaggerClient
    .then(function (client) {

      return client.PartManagement.Parts.GetSEDetailsByDPI(
        {

        },
        {
          requestBody: obj
        })
    .then(function(result) {
      console.log("then pm_getSEDetailsByDPI ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getSEDetailsByDPI error");
      console.log(reason);

    });
  })

}

export const pm_searchByMPN = ({}, obj) => {

console.log(obj)
  return swaggerClient
  .then(function(client){

    return client.PartManagement.Parts.SearchByMPN(obj)
    .then(function(result) {
      console.log("then pm_searchByMPN ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_searchByMPN error");
      console.log(reason);

    });
  })

}

//PM - Part Manager - UL #############################################################################
export const pm_searchByString = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.UltraLibrarian.SearchByString(obj)
        .then(function (result) {
        console.log("then pm_searchByString ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_searchByString error");
        console.log(reason);
        
      });
    })
  
}
export const pm_findPart = ({  }, obj) => {


    return swaggerClient
    .then(function(client){

      return client.PartManagement.UltraLibrarian.FindPart(obj)
        .then(function (result) {
        console.log("then pm_findPart ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_findPart error");
        console.log(reason);
        
      });
    })
  
}

export const pm_getDetails = ({  }, obj) => {



    return swaggerClient
    .then(function(client){

      return client.PartManagement.UltraLibrarian.GetDetails(obj)
        .then(function (result) {
        console.log("then pm_getDetails ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_getDetails error");
        console.log(reason);
        
      });
    })
  
}
export const pm_getFormats = ({  }, obj) => {


    return swaggerClient
    .then(function(client){

      return client.PartManagement.UltraLibrarian.GetFormats(obj)
        .then(function (result) {
        console.log("then pm_getFormats ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_getFormats error");
        console.log(reason);
        
      });
    })
  
}
export const pm_getOptions = ({  }) => {


    return swaggerClient
    .then(function(client){

      return client.PartManagement.UltraLibrarian.GetOptions()
        .then(function (result) {
        console.log("then pm_getOptions ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_getOptions error");
        console.log(reason);
        
      });
    })
  
}
export const pm_appendFilesToLibrary = ({  }, obj) => {


    return swaggerClient
    .then(function(client){

      return client.PartManagement.UltraLibrarian.AppendFilesToLibrary(obj)
        .then(function (result) {
        console.log("then pm_appendFilesToLibrary ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then pm_appendFilesToLibrary error");
        console.log(reason);
        
      });
    })
  
}
export const pm_getULLibraryType = ({  }) => {


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.GetLibraryType()
    .then(
      result => {
        console.log("pm_getULLibraryType ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getULLibraryType");
      }
    );
  });
};
export const pm_getULProperties = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.GetProperties(obj)
    .then(
      result => {
        console.log("pm_getULProperties ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getULProperties");
      }
    );
  });
};


export const pm_getPartsToWhichItIsAssigned = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetPartsToWhichItIsAssigned(obj)
    .then(
      result => {
        console.log("pm_getPartsToWhichItIsAssigned ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getPartsToWhichItIsAssigned");
      }
    );
  });
};

export const pm_getUsedMPNs = ({  }) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetUsedMPNs()
    .then(
      result => {
        console.log("pm_getUsedMPNs ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getUsedMPNs");
      }
    );
  });
};

export const pm_getGenericLibraries = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetGenericLibraries(obj)
    .then(
      result => {
        console.log("pm_getGenericLibraries ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getGenericLibraries");
      }
    );
  });
};

export const pm_getGenericCategories = ({  }) => {
  

  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetGenericCategories()
    .then(
      result => {
        console.log("pm_getGenericCategories ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getGenericCategories");
      }
    );
  });
};

export const pm_whatIsIncluded = ({  }, obj) => {
  

  
  return swaggerClient.then(client => {
    return client.PartManagement.Parts.WhatIsIncluded({ partRevisionId: obj.partRevisionId })
    .then(
      result => {
        console.log("pm_whatIsIncluded ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_whatIsIncluded");
      }
    );
  });
};

export const pm_getAltSymbolsParams = ({ }) => {
  
  
  return swaggerClient.then(client => {
    return client.PartManagement.Parts.GetAltSymbolsParams()
    .then(
      result => {
        console.log("pm_getAltSymbolsParams ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error pm_getAltSymbolsParams");
      }
    );
  });
};

export const pm_getPins = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.PartManagement.Parts.GetPins(obj)
    .then(function(result) {
      console.log("then pm_getPins ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getPins error");
      console.log(reason);

    });
  })

}

export const pm_getHistoryComments = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.PartManagement.Parts.GetHistoryComments(obj)
    .then(function(result) {
      console.log("then pm_getHistoryComments ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getHistoryComments error");
      console.log(reason);

    });
  })

}

export const pm_getRequestId = ({ }, obj) => {
  
  return swaggerClient
  .then(function(client){


    return client.PartManagement.Parts.GetRequestId(obj)
    .then(function(result) {
      console.log("then pm_getRequestId ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;

    }, function (reason) {
      console.log("init then pm_getRequestId error");
      console.log(reason);
      
    });
  })

}

//LM - Library Manager #############################################################################



export const lm_addActiveFilter = ({commit}, value) => {

  commit('LM_ADDACTIVEFILTER', value);

}

export const lm_deleteActiveFilter = ({commit}, value) => {

  commit('LM_DELETEACTIVEFILTER', value);

}

export const lm_deleteAllActiveFilters = ({commit}) => {

  commit('LM_DELETEALLACTIVEFILTERS');

}

export const lm_addActiveAction = ({commit}, obj) => {

  commit('LM_ADDACTIVEACTION', obj);

}

export const lm_deleteActiveAction = ({commit}, obj) => {

  commit('LM_DELETEACTIVEACTION', obj);

}

export const lm_deleteAllActiveActions = ({commit}) => {

  commit('LM_DELETEALLACTIVEACTIONS');

}

export const lm_getCategories = ({ commit }, obj) => {
  
  swaggerClient
  .then(function(client){

    client.LibraryManagement.Libraries.GetTree()
    .then(function(result) {
      console.log("then lm_getLibraryCategories ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      
      commit('GETDATATREELIBRARY', result.obj.data);
      
     
      // if (store.getters.selectedTreeLibraryItemObject == ""){
      //   const obj = result.obj.data;
      //   obj.children = [];

      //   commit("SELECTTREELIBRARYITEMOBJECT", obj);
      // }
      let commitType = "SELECTTREELIBRARYITEMOBJECT";

      if (store.getters.selectedTreeLibraryItemObject.categoryId == undefined) {
        selectCategoryChecker(result.obj.data, 1, commitType);    
      } else {
        selectCategoryChecker(result.obj.data, store.getters.selectedTreeLibraryItemObject.categoryId,commitType);    
      }

      
      
    }, function (reason) {
      console.log("lm_getLibraryCategories error");
      console.log(reason);
      
    });
  })


}
export const lm_getFlatCategories = ({}) => {



  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.GetTree()
    .then(function(result) {
      console.log("lm_getFlatCategories ok");

      //commit('GETDATATREE', result.obj.data);
      return result.obj
      
      

    }, function (reason) {
      console.log("lm_getFlatCategories error");
      console.log(reason);
      
    });
  })

}

export const lm_getLibraryFlatCategories = ({}) => {



  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.GetTree()
    .then(function(result) {
      console.log("lm_getLibraryFlatCategories ok");

      //commit('GETDATATREE', result.obj.data);
      return result.obj
      
      

    }, function (reason) {
      console.log("lm_getLibraryFlatCategories error");
      console.log(reason);
      
    });
  })

}

export const lm_createCategory = ({ commit }, obj) => {

  //let objAlertSuccess = obj.objAlertSuccess;
  //let objAlertError = obj.objAlertError;

  
  return swaggerClientFile.then(client => {
    return client.LibraryManagement.Libraries.CreateCategory(
      {
        fullPath: obj.fullPath,
        template: obj.template,
        libraryType: obj.libraryType,
        is4eyesRuleOff: obj.is4eyesRuleOff
      },
      {
        requestBody: {file: obj.file}
      })
    .then(
      result => {
        console.log("lm_createCategory ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        //commit("SETALERTCONTAINER", objAlertSuccess);
        return result.obj;
      },
      reason => {
        console.log(reason);
        //commit("SETALERTCONTAINER", objAlertError);
        console.log("error lm_createCategory");
      }
    );
  });
};
export const lm_updateCategory = ({ commit }, obj) => {
  
  let objAlertSuccess = obj.objAlertSuccess;
  let objAlertError = obj.objAlertError;

  
  return swaggerClientFile.then(client => {
    return client.LibraryManagement.Libraries.UpdateCategory(
      {
        fullPath: obj.fullPath,
        categoryId: obj.categoryId,
        template: obj.template,
        libraryType: obj.libraryType,
        is4eyesRuleOff: obj.is4eyesRuleOff
      },
      {
        requestBody: {file: obj.file}
      })
    .then(
      result => {
        console.log("lm_updateCategory ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        //commit("SETALERTCONTAINER", objAlertSuccess);
        return result.obj;
      },
      reason => {
        console.log(reason);
        //commit("SETALERTCONTAINER", objAlertError);
        console.log("error lm_updateCategory");
      }
    );
  });
};
export const lm_deleteLibraryCategory = ({ commit }, obj ) => {
  
  let objAlertSuccess = obj.objAlertSuccess;
  let objAlertError = obj.objAlertError;

  return swaggerClient.then(function(client){
    return client.LibraryManagement.Libraries.DeleteCategory({categoryId: obj.categoryId})
    .then(function(result) {
        console.log("ok lm_deleteLibraryCategory");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        if (result.obj.data == 1){
          commit("SETALERTCONTAINER", objAlertSuccess);
        }else{
          commit("SETALERTCONTAINER", objAlertError);

        }

        //return result;
      }, function (reason) {
        console.log(reason);
        commit("SETALERTCONTAINER", objAlertError);
        console.log("error lm_deleteLibraryCategory");
      }
    );
  });
};

export const lm_checkIfLibrariesInCategory  = ({  }, obj) => {
 
  return swaggerClient.then(function(client) {
    return client.LibraryManagement.Libraries.CheckIfLibrariesInCategory (obj).then(
      function(result) {
        console.log("then lm_checkIfLibrariesInCategory ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      function(reason) {
        console.log("init then lm_checkIfLibrariesInCategory error");
        console.log(reason);
        
      }
    );
  });
};

export const setLibraryCategoryMapping = ({commit}, obj) => {

  commit('SETPLIBRARYCATEGORYMAPPING', obj)
}

export const deleteLibraryCategoryMapping = ({commit}) => {

  commit('DELETELIBRARYCATEGORYMAPPING')
}

export const setElementCategoryLibrary = ({commit}, value) => {

  commit('SETELEMENTCATEGORYLIBRARY', value);

}

export const selectTreeLibraryItem = ({commit}, value) => {

  commit('SELECTTREELIBRARYITEM', value);

}

export const selectTreeLibraryItemObject = ({ commit }, value) => {
  commit("SELECTTREELIBRARYITEMOBJECT", value);
};

export const reloadAfterDeleteTreeLibraryItem = ({ commit }, value) => {
  commit("RELOADAFTERDELETETREELIBRARYITEM", value);
};

export const lm_getActions = ({}) => {

return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.GetActions()
    .then(function(result) {
      console.log("then lm_getActions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      
      return result.obj;

    }, function (reason) {
      console.log("init then lm_getActions error");
      console.log(reason);
      
    });
  })

}

export const lm_getProperties = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.GetProperties(obj)
    .then(
      result => {
        console.log("lm_getProperties ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_getProperties");
      }
    );
  });
};



export const lm_createProperty = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.CreateProperty(
      { categoryId: obj.categoryId},
      {
        requestBody: {
          propertyId: 0,
          name: obj.name,
          type: obj.type,
          isRequiredOnRequest: obj.isRequiredOnRequest,
          isRequiredOnRelease: obj.isRequiredOnRelease,
          isRevisionChanging: obj.isRevisionChanging,
          hdlGlobal: obj.hdlGlobal
        }
      }
    )
    .then(
      result => {
        console.log("lm_createProperty ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log("error lm_createProperty");
        console.log(reason);

      }
    );
  });
};

export const lm_updateProperty = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.UpdateProperty(
      { },
      {
        requestBody: {
          propertyId:obj.propertyId,
          name: obj.name,
          type: obj.type,
          isRequiredOnRequest: obj.isRequiredOnRequest,
          isRequiredOnRelease: obj.isRequiredOnRelease,
          isRevisionChanging: obj.isRevisionChanging,
          categoryId: obj.categoryId,
          hdlGlobal: obj.hdlGlobal,
          maxLength: obj.maxLength
        }
      })
    .then(
      result => {
        console.log("lm_updateProperty ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_updateProperty");
      }
    );
  });
};

export const lm_deleteProperty = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.DeleteProperty(obj)
    .then(
      result => {
        console.log("lm_deleteProperty ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_deleteProperty");
      }
    );
  });
};

export const lm_removeFileFromRevision = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.RemoveFileFromRevision(obj)
    .then(
      result => {
        console.log("lm_removeFileFromRevision ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_removeFileFromRevision");
      }
    );
  });
};

export const lm_getPropertiesType = ({  }) => {


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.GetPropertiesType()
    .then(
      result => {
        console.log("lm_getPropertiesType ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_getPropertiesType");
      }
    );
  });
};

export const lm_getQuickView = ({}, obj) => {

  return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.GetQuickView(
        {
          libraryRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then lm_getQuickView ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revision = obj.revision;
        return result.obj

      }, function (reason) {
        console.log("init then lm_getQuickView error");
        console.log(reason);
        
      });
    })

}
  
export const lm_getTasks = ({commit}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.GetTasks(obj)
      .then(function(result) {
        console.log("then lm_getTasks ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        if (result.obj.status == "OK") {
          commit("SETSECONDLEVEL", result.obj.data);
        }
        

        return result.obj
  
  
      }, function (reason) {
        console.log("init then lm_getTasks error");
        console.log(reason);
        
      });
    })
  
  }

  export const lm_setEventTask = ({}, obj) => {

  
    return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.SetEventTask(
        {
          
        },
        {
          requestBody: obj
        }
        )
      .then(function(result) {
        console.log("then lm_setEventTask ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj


      }, function (reason) {
        console.log("init then lm_setEventTask error");
        console.log(reason);
        
      });
    })

}
  
export const lm_setExistingTypes = ({ commit }, arr) => {

  commit("SETEXISTINGTYPES", arr);
}

export const lm_createNewLibrary = ({  }, obj) => {



  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.CreateNewLibrary(
      { 
        categoryId: obj.categoryId,
        distributorPartId: obj.distributorPartId,
      },
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log("lm_createNewLibrary ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error CreateNewPart");
      }
    );
  });
};
export const lm_createNewLibraryValidation = ({  }, arr) => {



  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.CreateNewLibraryValidation(
      { 
        
      },
      {
        requestBody: arr
      })
    .then(
      result => {
        console.log(" lm_createNewLibraryValidation ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_createNewLibraryValidation");
      }
    );
  });
};

export const lm_deriveLibrary = ({  }, obj) => {



  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.DeriveLibraries(
      { 
        categoryId: obj.categoryId,
        libraryRevisionId: obj.libraryRevisionId,
      },
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log(" lm_deriveLibrary ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_deriveLibrary");
      }
    );
  });
};

export const lm_updateLibrary = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.UpdateLibrary(
      { revisionId: obj.revisionId},
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log("lm_updateLibrary ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error UpdatePart");
      }
    );
  });
};

export const lm_updateLibraryValidation = ({  }, arr) => {



  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.UpdateLibraryValidation(
      { 
        
      },
      {
        requestBody: arr
      })
    .then(
      result => {
        console.log("lm_updateLibraryValidation ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_updateLibraryValidation");
      }
    );
  });
};

export const lm_getLibraryType = ({  }) => {


  return swaggerClient.then(client => {
    return client.LibraryManagement.Libraries.GetLibraryType()
    .then(
      result => {
        console.log("lm_getLibraryType ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error lm_getLibraryType");
      }
    );
  });
};

export const lm_getPart = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.GetLibrary(
        {
          partRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then lm_getPart ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revisionId = obj.revisionId;
        return result.obj

      }, function (reason) {
        console.log("init then lm_getPart error");
        console.log(reason);
        
      });
    })

} 
  export const lm_whereUse = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.WhereUse(obj)
      .then(function(result) {
        console.log("then lm_whereUse ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then lm_whereUse error");
        console.log(reason);
        
      });
    })
  
}

export const lm_whereLibUsed = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.WhereLibUsed(obj)
      .then(function(result) {
        console.log("then lm_whereLibUsed ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then lm_whereLibUsed error");
        console.log(reason);
        
      });
    })
  
}

export const lm_whatIsIncluded = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.WhatIsIncluded(obj)
      .then(function(result) {
        console.log("then lm_whatIsIncluded ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then lm_whatIsIncluded error");
        console.log(reason);
        
      });
    })
  
}
  
export const lm_getRevisionHistory = ({commit}, value) => {

  
  return swaggerClient
  .then(function(client){


    return client.LibraryManagement.Libraries.GetRevisionHistory(
      {
        libraryId: value
      })
    .then(function(result) {
      console.log("then lm_getRevisionHistory ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      commit('GETREVISIONHISTORY', result.obj.data);

      return result.obj

    }, function (reason) {
      console.log("init then lm_getRevisionHistory error");
      console.log(reason);

      
    });
  })


}

export const lm_getLibrary = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.GetLibrary(
        {
          libraryRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then lm_getLibrary ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revisionId = obj.revisionId;
        result.obj.revision = obj.revision;
        
        return result.obj;

      }, function (reason) {
        console.log("init then lm_getLibrary error");
        console.log(reason);
        
      });
    })

}  
  
export const lm_importImage = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      
      return client.LibraryManagement.Libraries.ImportImage( {
        revisionId: obj.revisionId,
        
      },
      {
        requestBody: {file: obj.file}
      })
      .then(function(result) {
                
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        
        
        return result.data
  
  
      }, function (reason) {
        console.log("then lm_importImage error");
        console.log(reason);
        
      });
    })
  
}
  
export const lm_importFiles = ({}, obj) => {

    return swaggerClient
    .then(function(client){
      
      return client.LibraryManagement.Libraries.ImportFiles( {
        revisionId: obj.revisionId,
        lastModified: obj.lastModified
      },
      {
        requestBody: {file: obj.file}
      })
      .then(function(result) {
        console.log("then lm_importFiles ok");        
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        
        //result.obj.data.fileName = obj.fileName;
        
        return result.obj;
  
  
      }, function (reason) {
        console.log("then lm_importFiles error");
        console.log(reason);
        
      });
    })
  
}
  
export const lm_getFiles = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.GetFiles(
        {
          revisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then lm_getFiles ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revisionId = obj.revisionId;
        return result.obj

      }, function (reason) {
        console.log("init then lm_getFiles error");
        console.log(reason);
        
      });
    })

}  

export const lm_getSvg = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      const objS = {
        type: obj.type,
        name: obj.name,
        revisionId: obj.revisionId
      }

      return client.LibraryManagement.Libraries.GetSvg(objS)
      .then(function(result) {
                
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        //console.log(result)
        //if (result.obj.data != null){
        //result.data.id = obj.id;
        
        //}

        if (typeof result.data == "object") {
          
          result.data.id = obj.id;
          result.data.noImage = false;
          result.data.revisionId = obj.revisionId;

        } else {
          
          result.obj.id = obj.id;       
          result.obj.noImage = true;
          result.obj.revisionId = obj.revisionId;
          return result.obj;
          
        }
        
        
        return result.data
  
  
      }, function (reason) {
        console.log("then getSvg error");
        console.log(reason);
        
      });
    })
  
}
  
export const lm_downloadFile = ({}, obj) => {

        return swaggerClient
        .then(function(client){
    
          return client.LibraryManagement.Libraries.DownloadFile(obj)
          .then(function(result) {
            console.log(result)
            console.log("lm_downloadFile ok");
            // if (result.obj.status == "ERROR"){
            //   checkReason(result);
            // }
            return result.data;
      
      
          }, function (reason) {
            console.log("lm_downloadFile error");
            console.log(reason);
            
          });
        })
      
}

export const lm_checkLibrary = ({  }, obj) => {
  
  let revisionId = obj.revisionId;

  

  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
    console.log(isAvailable)
    if(isAvailable){
      return agentAPI.checkLibrary(revisionId);
    } else {
      return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
    }
    

  })
  .then(null, agentAPI.wrapOutErrorPromise);

  
}
export const lm_confirm = ({  }) => {}

export const lm_trySyncSchematicLibrary = ({  }) => {
  // TODO: store the timeout object and cancel it here to allow manual triggering of this dispatch without multiplying intervals
  let checkAvailabilityResult = null;
  let syncLibraryFilesResult = null;

  
  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
      checkAvailabilityResult = isAvailable;
      if (isAvailable) {
        
        return agentAPI.syncLibraryFiles()
          .then(function (result) {
          syncLibraryFilesResult = result.data;
          if (syncLibraryFilesResult.requiredConcatinations.length>0) {
            if (store.getters.isPlugin) {
              let concatErrors = [];
              let chainedConcatPromises = $.Deferred().resolve(null).promise();
              for (let concatParams of syncLibraryFilesResult.requiredConcatinations) {
                chainedConcatPromises = chainedConcatPromises.then(
                  function() {
                    return tclAPI.concatOlb(concatParams.sourceFolderPath,concatParams.targetOlbFilePath);
                  }/*,
                  function(err) {
                    console.log('olb concat error')
                    //mak sure that the errors are directly in err as a string and push to concatErrors
                    return tclAPI.concatOlb(concatParams.sourceFolderPath,concatParams.targetOlbFilePath);
                  }*/ // actually lets break at first error, because it wont change anything if we sync partially
                );
              }
              chainedConcatPromises = chainedConcatPromises.then(
                function() {
                  return $.Deferred().resolve({status:"OK",data:concatErrors}).promise();
                }/*,
                function(err) {
                  console.log('olb concat error')
                  //mak sure that the errors are directly in err as a string and push to concatErrors
                  return $.Deferred().resolve({status:"OK",data:concatErrors}).promise();
                }*/ // actually lets break at first error, because it wont change anything if we sync partially
              );
              chainedConcatPromises = chainedConcatPromises.then(
                function(){tclAPI.refreshSymbolInfo();}
              );
              return chainedConcatPromises.then(
                function(){
                  return agentAPI.mergeConcatinatedOlbs();
                }
              );
              

            } else {
              console.log('not in the plugin, we should notify the user somehow to open plugin to finish synchronization');
              console.log('maybe by setting some flag on the vue store that will cause visibility on some kind of notification');
            }
          } else if (syncLibraryFilesResult.stage === 'confirm') {
            return agentAPI.syncLibraryFiles({confirmed:true})
          } else if (syncLibraryFilesResult.stage === 's') {
            return agentAPI.syncLibraryFiles({confirmed:true})
          } else {
            return $.Deferred().resolve().promise();
          }
        })
        
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
      }

    })
    .then(function () {
      return $.Deferred().resolve({
        status: "OK", data: {
          checkAvailabilityResult: checkAvailabilityResult,
          syncLibraryFilesResult: syncLibraryFilesResult,
        }
      })
    })
    .then(null, agentAPI.wrapOutErrorPromise)
    .finally(()=>{
      setTimeout(()=>store.dispatch('lm_trySyncSchematicLibrary'),1000);
    });;
}

export const lm_updateSymbolPins = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.UpdateSymbolPins(
        {
          libraryRevisionId: obj.libraryRevisionId
        },
        {
          requestBody: obj.json
        }
      )
      .then(function(result) {
        console.log("then lm_updateSymbolPins ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        return result.obj

      }, function (reason) {
        console.log("init then lm_updateSymbolPins error");
        console.log(reason);
        
      });
    })

}  

export const lm_openLibrary = ({  }, obj) => {
console.log("lm_openLibrary remote")
  //if ((obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL) && !store.getters.isPlugin) {
    
    //return {status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"}
    //return $.Deferred().resolve({status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"}).promise();
  //}

  let revisionId = obj.revisionId;
  
  let checkAvailabilityResult = null;
  let pullLibraryFilesResult = null;
  let openLibraryResult = null; 

  
  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
      checkAvailabilityResult = isAvailable;
      if (isAvailable) {
        return agentAPI.pullLibraryFiles(revisionId)
          .then(function (result) {
          pullLibraryFilesResult = result;
          if (store.getters.isPlugin) {
            return agentAPI.openLibrary(revisionId)
              .then(function (result) {
                openLibraryResult = result;
                console.log(result)
                return tclAPI.openLibraryFromOmnya(obj);
              })
          } else if (obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL) {
            return agentAPI.openLibrary(revisionId)
            .then(function (result) {
              openLibraryResult = result;
              console.log(result)
              $.Deferred().resolve(result).promise();
            });
          } else {
            return agentAPI.openLibraryNoPlugin(revisionId)
            .then(function (result) {
              openLibraryResult = result;
              console.log(result)
              $.Deferred().resolve(result).promise();
            });
          }
        })
        
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
      }

    })
    .then(function () {
      return $.Deferred().resolve({
        status: "OK", data: {
          checkAvailabilityResult: checkAvailabilityResult,
          pullLibraryFilesResult: pullLibraryFilesResult,
          openLibraryResult: openLibraryResult
        }
      })
    })
    .then(null, agentAPI.wrapOutErrorPromise);
}
export const lm_openLibraryLocally = ({  }, obj) => {
  console.log("lm_openLibraryLocally")
  //if ((obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL) && !store.getters.isPlugin) {
    
    //return {status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"}
    //return $.Deferred().resolve({status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"}).promise();
  //}

  let revisionId = obj.revisionId;
  
  let checkAvailabilityResult = null;
  let pullLibraryFilesResult = null;
  let openLibraryResult = null; 

  
  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
      checkAvailabilityResult = isAvailable;
      if (isAvailable) {
        
          if (store.getters.isPlugin) {
            return agentAPI.openLibrary(revisionId)
              .then(function (result) {
                openLibraryResult = result;
                console.log(result)
                return tclAPI.openLibraryFromOmnya(obj);
              })
          } else if (obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL) {
            return agentAPI.openLibrary(revisionId)
            .then(function (result) {
              openLibraryResult = result;
              console.log(result)
              $.Deferred().resolve(result).promise();
            });
          }  else {
            return agentAPI.openLibraryNoPlugin(revisionId)
            .then(function (result) {
              openLibraryResult = result;
              console.log(result)
              $.Deferred().resolve(result).promise();
            });
          }
        
        
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
      }

    })
    .then(function () {
      return $.Deferred().resolve({
        status: "OK", data: {
          checkAvailabilityResult: checkAvailabilityResult,
          pullLibraryFilesResult: null,
          openLibraryResult: openLibraryResult
        }
      })
    })
    .then(null, agentAPI.wrapOutErrorPromise);
}


export const lm_pushLibrary = ({}, obj) => {

  let revisionId = obj.revisionId;
 
  

  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
      if (isAvailable) {
        if (store.getters.isPlugin && (obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL)) {
          return tclAPI.makeSymbolSVG(obj.name,obj.type,obj.category)
            .then(function (resp) {
              let errorsList = JSON.parse(resp.errors);
              if (resp.json == "") {
                return $.Deferred().reject(errorsList).promise();
              }
              console.log(resp.json)
              

              let jsonString = JSON.parse(resp.json);
              //console.log("parsing symbol json to svg from:");
              
              if (obj.type === LibraryTypes.PART) {
                let obj = {
                libraryRevisionId: revisionId,
                json: jsonString
              }
              
              store.dispatch("lm_updateSymbolPins", obj);
              }
              
              var svgStr = Json2Svg.create(jsonString, 400, 400);
              //console.log("here is the svg that was generated:");
              
              return agentAPI.saveLocalSvg(revisionId,svgStr);
            },
            function(resp){
              //unwrapping the error from tclApi after makeSybolSVG is called
              
              return $.Deferred().reject({status:"ERROR",message:resp.toString()}).promise();
            })
        } else if (!store.getters.isPlugin && (obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL)) {
          return $.Deferred().reject({status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic libraries"});
        } else if (obj.type === LibraryTypes.FOOTPRINT || obj.type === LibraryTypes.MECHANICAL) {
          return agentAPI.makeFootprintSVG(revisionId);
        }
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"});
      }


    })
    .then(function(){
      if (store.getters.isPlugin && (obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL)) {
        return tclAPI.pushLibraryToOmnya(obj);
      }
    }).then(function (result) {
      console.log(result)
      return agentAPI.pushLibrary(revisionId);
    })
    .then(null, agentAPI.wrapOutErrorPromise);

  

}

export const lm_setEventTaskForm = ({commit}, obj) => {

  commit("SETEVENTTASKFORM", obj)
}

export const lm_getActiveLibraries = ({}, obj) => {

        return swaggerClient
        .then(function(client){
    
          return client.LibraryManagement.Libraries.GetActiveLibraries( {
            categoryId: obj.categoryId,
            
          },
          {
            requestBody: obj.actions
          })
          .then(function(result) {
            
            console.log("lm_downloadFile ok");
            // if (result.obj.status == "ERROR"){
            //   checkReason(result);
            // }
            return result.data;
      
      
          }, function (reason) {
            console.log("lm_downloadFile error");
            console.log(reason);
            
          });
        })
      
}

export const lm_uploadSvg = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    const objS = {
      type: obj.type,
      name: obj.name
    }

    return client.PartManagement.Parts.UploadSvg( {
      type: obj.type,
      
    },
    {
      requestBody: {file: obj.file}
    })
    .then(function(result) {
              
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
      
      return result.data


    }, function (reason) {
      console.log("then uploadSvg error");
      console.log(reason);
      
    });
  })

}

export const lm_bulkCheckMovingToAnotherCategory = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.BulkCheckMovingToAnotherCategory(
      {},
      {
        requestBody: obj
      })
    .then(function(result) {
      console.log("then lm_bulkCheckMovingToAnotherCategory ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_bulkCheckMovingToAnotherCategory error");
      console.log(reason);

    });
  })

}

export const lm_bulkMoveToAnotherCategory = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.BulkMoveToAnotherCategory(
      {},
      {
        requestBody: obj
      })
    .then(function(result) {
      console.log("then lm_bulkMoveToAnotherCategory ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_bulkMoveToAnotherCategory error");
      console.log(reason);

    });
  })

}

export const lm_moving = ({commit}, obj) => {

    commit("MOVING", obj)
}

export const lm_bulkRemoveRevision = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.LibraryManagement.Libraries.BulkRemoveRevision(
      {

      },
      {
        requestBody: obj.libraryRevisionIds
      })
    .then(function(result) {
      console.log("then lm_bulkRemoveRevision ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_bulkRemoveRevision error");
      console.log(reason);

    });
  })

}

//unverified



// export const lm_getFilters = ({commit}, obj) => {

// swaggerClient
//   .then(function(client){

//     client.LibraryManagement.Libraries.GetFilters()
//     .then(function(result) {
//       console.log("then lm_getFilters ok");

//       commit('GETFILTERS', result.obj.data);

//     }, function (reason) {
//       console.log("init then lm_getFilters error");
//       console.log(reason);
//       //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
//     });
//   })

// }



export const lm_getFormDetails = ({commit}, obj) => {


  swaggerClient
  .then(function(client){




    client.LibraryManagement.Libraries.GetFormDetails({category: obj.category, keys:obj.keys})
    .then(function(result) {
      console.log("then lm_getFormDetails ok");
      console.log(result.obj.data)
      commit('GETFORMDETAILS', result.obj.data);

    }, function (reason) {
      console.log("init then lm_getFormDetails error");
      console.log(reason);
      //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
    });
  })


}

export const lm_getNewFormDetails = ({commit}, value) => {


  swaggerClient
  .then(function(client){




    client.LibraryManagement.Libraries.GetNewFormDetails({category: value})
    .then(function(result) {
      console.log("then lm_getNewFormDetails ok");

      commit('GETFORMDETAILS', result.obj.data);

    }, function (reason) {
      console.log("init then lm_getNewFormDetails error");
      console.log(reason);
      //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
    });
  })


}

// export const lm_getQuickView = ({commit}, obj) => {

//   swaggerClient
//     .then(function(client){

//       client.LibraryManagement.Libraries.GetQuickView({key:obj.key})
//       .then(function(result) {
//         console.log("then lm_getQuickView ok");

//         commit('GETDETAILS', result.obj.data);

//       }, function (reason) {
//         console.log("init then lm_getQuickView error");
//         console.log(reason);
//         //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
//       });
//     })

//   }

//   
export const lm_bulkSetWithdraw = ({ }, obj) => {
  
  
  return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.BulkSetWithdraw(
        { 
          
        },
        {
          requestBody: obj.libraryIds
        })
      .then(function(result) {
        console.log("then lm_bulkSetWithdraw ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
        

      }, function (reason) {
        console.log("init then lm_bulkSetWithdraw error");
        console.log(reason);
        
      });
    })

  }
export const lm_bulkDeleteLibrary = ({ }, obj) => {
  
  
 
  return swaggerClient
    .then(client => {
      return client.LibraryManagement.Libraries.BulkDeleteLibrary(
        {},
        {
          requestBody: obj.libraryIds
        })
      .then((result) => {
        console.log(" lm_bulkDeleteLibrary ok");
        if (result.obj.status == "ERROR") {
          checkReason(result);
        }

        return result.obj;
      },
        reason => {
          console.log(reason);
          console.log("error lm_bulkDeleteLibrary");
        }
      )
      
  })
  .catch((reason) => {
    console.warn(reason);
    return reason
  })
};

    export const lm_getPinsTable = ({commit}, obj) => {

      swaggerClient
        .then(function(client){

          client.LibraryManagement.Libraries.GetPinsTable({key:obj.key})
          .then(function(result) {
            console.log("then lm_getPinsTable ok");

            if (obj.details == true){
              commit('GETPINSTABLEDETAILS', result.obj.data);
            }else{
              commit('GETPINSTABLE', result.obj.data);
            }


          }, function (reason) {
            console.log("init then lm_getPinsTable error");
            console.log(reason);
            //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
          });
        })

      }

      export const lm_getUseInTable = ({commit}, obj) => {

        swaggerClient
          .then(function(client){

            client.LibraryManagement.Libraries.GetUseInTable({key:obj.key})
            .then(function(result) {
              console.log("then lm_getUseInTable ok");

              if (obj.details == true){
                commit('GETUSEINTABLEDETAILS', result.obj.data);
              }else{
                commit('GETUSEINTABLE', result.obj.data);
              }




            }, function (reason) {
              console.log("init then lm_getUseInTable error");
              console.log(reason);
              //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
            });
          })

        }


        export const lm_getDependOnTable = ({commit}, obj) => {

          swaggerClient
            .then(function(client){

              client.LibraryManagement.Libraries.GetDependOnTable({key:obj.key})
              .then(function(result) {
                console.log("then lm_getDependOnTable ok");


                if (obj.details == true){
                  commit('GETDEPENDONTABLEDETAILS', result.obj.data);
                }else{
                  commit('GETDEPENDONTABLE', result.obj.data);
                }


              }, function (reason) {
                console.log("init then lm_getDependOnTable error");
                console.log(reason);
                //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
              });
            })

          }

          // export const lm_getTasksTable = ({commit}, obj) => {

          //   swaggerClient
          //     .then(function(client){

          //       client.LibraryManagement.Libraries.GetTasks({key:obj.key})
          //       .then(function(result) {
          //         console.log("then lm_getTasksTable ok");

          //         commit('GETTASKSTABLE', result.obj.data.data);

          //         if (obj.details == true){
          //           commit('GETTASKSTABLEDETAILS', result.obj.data.data);
          //         }else{
          //           commit('GETTASKSTABLE', result.obj.data.data);
          //         }

          //       }, function (reason) {
          //         console.log("init then lm_getTasksTable error");
          //         console.log(reason);
          //         //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
          //       });
          //     })

          //   }

          //   export const lm_setEventTask = ({commit}, obj) => {

          //     swaggerClient
          //       .then(function(client){

          //         client.LibraryManagement.Libraries.SetEventTask({processId: obj.processId, diagramTaskId: obj.diagramTaskId, actions: obj.action})
          //         .then(function(result) {
          //           console.log("then lm_setEventTask ok");

          //           commit('EVENTTASKRESPONSE', result.obj.data);

          //         }, function (reason) {
          //           console.log("init then lm_setEventTask error");
          //           console.log(reason);
          //           //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
          //         });
          //       })

          //     }

  export const lm_getPossibleValueForCombo = ({commit}, value) => {

    swaggerClient
      .then(function(client){

        client.LibraryManagement.Libraries.GetPossibleValueForCombo({key:value})
        .then(function(result) {
          console.log("then lm_getPossibleValueForCombo ok");

          commit('GETPOSSIBLEVALUEFORCOMBO', result.obj.data);

        }, function (reason) {
          console.log("init then lm_getPossibleValueForCombo error");
          console.log(reason);
          //this.$store.dispatch('setAlert', {where:"getData2", what:reason});
        });
      })

    }
    export const lm_saveData = ({}, obj) => {

      

      return swaggerClient
        .then(function(client){



          return client.LibraryManagement.Libraries.SaveData({obj: obj})
          .then(function(result) {
            console.log("then lm_saveData ok");

            try{

              var res = {}

              if (result.obj == undefined){
                
                res.message = ""
                res.ok = true

                return res

              }else{
                
                res.message = result.message
                res.ok = false

                return res
              }


            }catch(e){
              console.log("Error:")
              console.log(e)
            }
          }, function (reason) {
            console.log("init then lm_saveData error");
            console.log(reason);

            try{

              var res = {}

              if (reason.response.obj.status == "ERROR"){
                
                res.message = reason.response.obj.message
                res.ok = false

                return res

              }


            }catch(e){
              console.log("Error:")
              console.log(e)
            }

          });
        })

      }

      export const lm_getProcessId = ({commit}, value) => {



        swaggerClient
        .then(function(client){

          client.LibraryManagement.Libraries.GetProcessId({key:value})
          .then(function(result) {
            console.log("then lm_getProcessId ok");


            commit('GETPROCESSID', result.obj.data);


          }, function (reason) {
            console.log("init then lm_getProcessId error");
            console.log(reason);
            //this.$store.dispatch('setAlert', {where:"getDataTree", what:reason});
          });
        })

      }

export const lm_validate = ({}, obj) => {



  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.Validate({key:obj.key, value:obj.value})
    .then(function(result) {
      console.log("then lm_validate ok");


      return result.obj.data


    }, function (reason) {
      console.log("init then lm_validate error");
      console.log(reason);
      //this.$store.dispatch('setAlert', {where:"getDataTree", what:reason});
    });
  })

}  
                  
export const lm_setExtensions = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.SetExtensions(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then lm_setExtensions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_setExtensions error");
      console.log(reason);

    });
  })

}

export const lm_getExtensions = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.GetExtensions()
    .then(function(result) {
      console.log("then lm_getExtensions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_getExtensions error");
      console.log(reason);

    });
  })

}

export const lm_changePropertyPriority = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.ChangePropertyPriority(
      {

      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then lm_changePropertyPriority ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_changePropertyPriority error");
      console.log(reason);

    });
  })

}

export const lm_getIdOfActiveLibrary = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.GetIdOfActiveLibrary(
      {

      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then lm_getIdOfActiveLibrary ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      } else {
        result.obj.data.idL = obj.idL;
      }

      
      return result.obj;


    }, function (reason) {
      console.log("then lm_getIdOfActiveLibrary error");
      console.log(reason);

    });
  })

}

export const lm_transferOfOwnership = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.TransferOfOwnership(obj)
    .then(function(result) {
      console.log("then lm_transferOfOwnership ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_transferOfOwnership error");
      console.log(reason);

    });
  })

}

export const lm_getAutocompleteValues = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.LibraryManagement.Libraries.GetAutocompleteValues(obj)
    .then(function(result) {
      console.log("then lm_getAutocompleteValues ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_getAutocompleteValues error");
      console.log(reason);

    });
  })

}

export const lm_setLibStatuses = ({commit}, arr) => {

  commit("SETLIBSTATUSES", arr)

}

export const lm_checkIfLibrariesReady = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.LibraryManagement.Libraries.CheckIfLibrariesReady(obj)
    .then(function(result) {
      console.log("then lm_checkIfLibrariesReady ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_checkIfLibrariesReady error");
      console.log(reason);

    });
  })

}



export const lm_getHDLFiles = ({  }, obj) => {

  
  return swaggerClient
  .then(function(client){

    return client.LibraryManagement.Libraries.GetHDLFiles(obj)
    .then(function(result) {
      console.log("then lm_getHDLFiles ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      //commit('GETDATATREEFOLDER', result.obj.data);
      return result.obj;
      
      // if (store.getters.selectedTreeProjectItemObject == ""){
      //   const obj = result.obj.data;
      //   obj.children = [];

      //   commit("SELECTTREEFOLDERITEMOBJECT", obj);
      // }

      
      
    }, function (reason) {
      console.log("lm_getHDLFiles error");
      console.log(reason);
      
    });
  })
}

export const lm_getFilesComparison  = ({  }, obj) => {

  return swaggerClient.then(function(client){
    return client.LibraryManagement.Libraries.FilesComparison({ 
        
      },
      {
        requestBody: obj
      })
    .then(function(result) {
        console.log("then lm_filesComparison ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then lm_filesComparison error");
      }
    );
  });
}

export const lm_getHDLSymbols  = ({  }) => {


  return swaggerClient.then(function(client){
    return client.LibraryManagement.Libraries.GetHDLSymbols()
    .then(function(result) {
        console.log("then lm_getHDLSymbols ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then lm_getHDLSymbols error");
      }
    );
  });
}

export const lm_getLibraryDetails = ({ }, obj) => {
  
  
  return swaggerClient.then(function(client) {
    return client.LibraryManagement.Libraries.GetLibraryDetails (obj).then(
      function(result) {
        console.log("then lm_getLibraryDetails ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      function(reason) {
        console.log("then lm_getLibraryDetails error");
        console.log(reason);
        
      }
    );
  });
  
  
};

export const lm_getCategoryByRevisionId = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.LibraryManagement.Libraries.GetCategoryByRevisionId(obj)
    .then(function(result) {
      console.log("then pm_getCategoryByRevisionId ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getCategoryByRevisionId error");
      console.log(reason);

    });
  })

}

export const lm_getPins = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.LibraryManagement.Libraries.GetPins(obj)
    .then(function(result) {
      console.log("then lm_getPins ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_getPins error");
      console.log(reason);

    });
  })

}

export const lm_getHistoryComments = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.LibraryManagement.Libraries.GetHistoryComments(obj)
    .then(function(result) {
      console.log("then lm_getHistoryComments ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then lm_getHistoryComments error");
      console.log(reason);

    });
  })

}

export const lm_getRequestId = ({}, obj) => {

  return swaggerClient
  .then(function(client){


    return client.LibraryManagement.Libraries.GetRequestId(obj)
    .then(function(result) {
      console.log("then lm_getRequestId ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      
      return result.obj;

    }, function (reason) {
      console.log("init then lm_getRequestId error");
      console.log(reason);
      
    });
  })

}    

//projm - Project Manager #############################################################################



export const projm_addActiveFilter = ({commit}, value) => {

  commit('PROJM_ADDACTIVEFILTER', value);

}

export const projm_deleteActiveFilter = ({commit}, value) => {

  commit('PROJM_DELETEACTIVEFILTER', value);

}

export const projm_deleteAllActiveFilters = ({commit}) => {

  commit('PROJM_DELETEALLACTIVEFILTERS');

}

export const projm_addActiveAction = ({commit}, obj) => {

  commit('PROJM_ADDACTIVEACTION', obj);

}

export const projm_deleteActiveAction = ({commit}, obj) => {

  commit('PROJM_DELETEACTIVEACTION', obj);

}

export const projm_deleteAllActiveActions = ({commit}) => {

  commit('PROJM_DELETEALLACTIVEACTIONS');

}

export const projm_getProjectCategories = ({ commit }, obj) => {
  
  swaggerClient
  .then(function(client){

    client.ProjectManagement.Projects.GetTree()
      .then(function (result) {
      
      console.log("then projm_getProjectCategories ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
    

      commit('GETDATATREEPROJECT', result.obj.data);
      
        let commitType = "SELECTTREEPROJECTITEMOBJECT";     
        
        if (store.getters.selectedTreeProjectItemObject.categoryId == undefined) {
          
          selectCategoryChecker(result.obj.data, 1, commitType);    
        } else {
          
          selectCategoryChecker(result.obj.data, store.getters.selectedTreeProjectItemObject.categoryId, commitType);    
        }
           
        
      
    }, function (reason) {
      console.log("projm_getProjectCategories error");
      console.log(reason);
      
    });
  })


}



export const projm_createCategory = ({ commit }, obj) => {

  //let objAlertSuccess = obj.objAlertSuccess;
  //let objAlertError = obj.objAlertError;

  
  return swaggerClientFile.then(client => {
    return client.ProjectManagement.Projects.CreateCategory(
      {
        fullPath: obj.fullPath,
        template: obj.template
      },
      {
        requestBody: {file: obj.file}
      })
    .then(
      result => {
        console.log("projm_createCategory ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        //commit("SETALERTCONTAINER", objAlertSuccess);
        return result.obj;
      },
      reason => {
        
        //commit("SETALERTCONTAINER", objAlertError);
        console.log("error projm_createCategory");
        console.log(reason);
      }
    );
  });
};
export const projm_updateCategory = ({ commit }, obj) => {
  
  //let objAlertSuccess = obj.objAlertSuccess;
  //let objAlertError = obj.objAlertError;

  
  return swaggerClientFile.then(client => {
    return client.ProjectManagement.Projects.UpdateCategory(
      {
        fullPath: obj.fullPath,
        categoryId: obj.categoryId,
        template: obj.template
      },
      {
        requestBody: {file: obj.file}
      })
    .then(
      result => {
        console.log("projm_updateCategory ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        //commit("SETALERTCONTAINER", objAlertSuccess);
        return result.obj;
      },
      reason => {
        console.log(reason);
        //commit("SETALERTCONTAINER", objAlertError);
        console.log("error projm_updateCategory");
      }
    );
  });
};
export const projm_deleteProjectCategory = ({ commit }, obj ) => {
  
  let objAlertSuccess = obj.objAlertSuccess;
  let objAlertError = obj.objAlertError;

  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.DeleteCategory({categoryId: obj.categoryId})
    .then(function(result) {
        console.log("ok projm_deleteProjectCategory");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        if (result.obj.data == 1){
          commit("SETALERTCONTAINER", objAlertSuccess);
        }else{
          commit("SETALERTCONTAINER", objAlertError);

        }

        //return result;
      }, function (reason) {
        console.log(reason);
        commit("SETALERTCONTAINER", objAlertError);
        console.log("error projm_deleteProjectCategory");
      }
    );
  });
};

export const projm_checkIfProjectsInCategory  = ({  }, obj) => {
 
  return swaggerClient.then(function(client) {
    return client.ProjectManagement.Projects.CheckIfProjectsInCategory (obj).then(
      function(result) {
        console.log("then projm_checkIfProjectsInCategory ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      function(reason) {
        console.log("init then projm_checkIfProjectsInCategory error");
        console.log(reason);
        
      }
    );
  });
};

export const projm_checkIfItemInCategory  = ({  }, obj) => {
 
  return swaggerClient.then(function(client) {
    return client.ProjectManagement.Projects.CheckIfItemsInFolder (obj).then(
      function(result) {
        console.log("then projm_checkIfItemInCategory ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      function(reason) {
        console.log("init then projm_checkIfItemInCategory error");
        console.log(reason);
        
      }
    );
  });
};

// export const projm_setProjectCategoryMapping = ({commit}, obj) => {

//   commit('SETPLIBRARYCATEGORYMAPPING', obj)
// }

export const projm_deleteProjectCategoryMapping = ({commit}) => {

  commit('DELETEPROJECTCATEGORYMAPPING')
}

export const projm_setElementCategoryProject = ({commit}, value) => {

  commit('SETELEMENTCATEGORYPROJECT', value);

}

export const projm_selectTreeProjectItem = ({commit}, value) => {

  commit('SELECTTREEPROJECTITEM', value);

}

export const projm_selectTreeProjectItemObject = ({ commit }, value) => {
  commit("SELECTTREEPROJECTITEMOBJECT", value);
};

export const projm_reloadAfterDeleteTreeProjectItem = ({ commit }, value) => {
  commit("RELOADAFTERDELETETREEPROJECTITEM", value);
};

export const projm_getActions = ({}) => {

return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetActions()
    .then(function(result) {
      console.log("then projm_getActions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      //commit('GETFILTERS', result.obj.data);
      return result.obj;

    }, function (reason) {
      console.log("init then projm_getActions error");
      console.log(reason);
      
    });
  })

}

export const projm_getProperties = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.GetProperties(obj)
    .then(
      result => {
        console.log("projm_getProperties ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_getProperties");
      }
    );
  });
};



export const projm_createProperty = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.CreateProperty(
      { categoryId: obj.categoryId},
      {
        requestBody: {
          propertyId: 0,
          name: obj.name,
          type: obj.type,
          isRequiredOnRequest: obj.isRequiredOnRequest,
          isRequiredOnRelease: obj.isRequiredOnRelease,
          isRevisionChanging: obj.isRevisionChanging,
        }
      }
    )
    .then(
      result => {
        console.log("projm_createProperty ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log("error projm_createProperty");
        console.log(reason);

      }
    );
  });
};

export const projm_updateProperty = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.UpdateProperty(
      { },
      {
        requestBody: {
          propertyId:obj.propertyId,
          name: obj.name,
          type: obj.type,
          isRequiredOnRequest: obj.isRequiredOnRequest,
          isRequiredOnRelease: obj.isRequiredOnRelease,
          isRevisionChanging: obj.isRevisionChanging,
          categoryId: obj.categoryId,
          maxLength: obj.maxLength
        }
      })
    .then(
      result => {
        console.log("projm_updateProperty ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_updateProperty");
      }
    );
  });
};

export const projm_deleteProperty = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.DeleteProperty(obj)
    .then(
      result => {
        console.log("projm_deleteProperty ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_deleteProperty");
      }
    );
  });
};

export const projm_getPropertiesType = ({  }) => {


  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.GetPropertiesType()
    .then(
      result => {
        console.log("projm_getPropertiesType ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_getPropertiesType");
      }
    );
  });
};

export const projm_getQuickView = ({}, obj) => {

  return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetQuickView(
        {
          projectRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then projm_getQuickView ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revision = obj.revision;
        return result.obj

      }, function (reason) {
        console.log("init then projm_getQuickView error");
        console.log(reason);
        
      });
    })

}
  
// export const projm_getTasks = ({commit}, obj) => {

//     return swaggerClient
//     .then(function(client){

//       return client.ProjectManagement.Projects.GetTasks(obj)
//       .then(function(result) {
//         console.log("then lm_getTasks ok");
//         if (result.obj.status == "ERROR"){
//           checkReason(result);
//         }
//         return result.obj
  
  
//       }, function (reason) {
//         console.log("init then lm_getTasks error");
//         console.log(reason);
        
//       });
//     })
  
//   }

//   export const projm_setEventTask = ({commit}, obj) => {
//     console.log(obj)
  
//     return swaggerClient
//     .then(function(client){

//       return client.LibraryManagement.Libraries.SetEventTask(
//         {
          
//         },
//         {
//           requestBody: obj
//         }
//         )
//       .then(function(result) {
//         console.log("then lm_setEventTask ok");
//         if (result.obj.status == "ERROR"){
//           checkReason(result);
//         }

//         return result.obj


//       }, function (reason) {
//         console.log("init then lm_setEventTask error");
//         console.log(reason);
        
//       });
//     })

// }
  
export const projm_setExistingTypes = ({ commit }, arr) => {

  commit("SETEXISTINGTYPES", arr);
}

export const projm_createNewProject = ({  }, obj) => {



  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.CreateNewProject(
      { 
        categoryId: obj.categoryId,
        distributorPartId: obj.distributorPartId,
      },
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log(" projm_createNewProject....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_createNewProject");
      }
    );
  });
};

export const projm_createNewProjectValidation = ({  }, arr) => {



  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.CreateNewProjectValidation(
      { 
        
      },
      {
        requestBody: arr
      })
    .then(
      result => {
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        console.log(" projm_createNewProjectValidation....");
        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_createNewProjectValidation");
      }
    );
  });
};

export const projm_updateProject = ({  }, obj) => {
  


  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.UpdateProject(
      { revisionId: obj.revisionId},
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log(" projm_updateProject....");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_updateProject");
      }
    );
  });
};

export const projm_updateProjectValidation = ({  }, arr) => {



  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.UpdateProjectValidation(
      { 
        
      },
      {
        requestBody: arr
      })
    .then(
      result => {
        console.log("projm_updateProjectValidation ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_updateProjectValidation");
      }
    );
  });
};

export const projm_getProjectType = ({  }) => {


  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.GetProjectType()
    .then(
      result => {
        console.log("projm_getProjectType ok");
        
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_getProjectType");
      }
    );
  });
};

// export const projm_getProject = ({commit}, obj) => {
  
//   return swaggerClient
//     .then(function(client){

//       return client.ProjectManagement.Projects.GetProject(
//         {
//           partRevisionId: obj.revisionId
//         }
//       )
//       .then(function(result) {
//         console.log("then projm_getProject ok");
//         if (result.obj.status == "ERROR"){
//           checkReason(result);
//         }
//         //commit('GETDETAILS', result.obj.data);
//         result.obj.revision = obj.revisionId;
//         return result.obj

//       }, function (reason) {
//         console.log("init then projm_getProject error");
//         console.log(reason);
        
//       });
//     })

// } 
  export const projm_whereUse = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.LibraryManagement.Libraries.WhereUse(obj)
      .then(function(result) {
        console.log("then projm_whereUse ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_whereUse error");
        console.log(reason);
        
      });
    })
  
}


  
export const projm_getRevisionHistory = ({commit}, value) => {

  
  return swaggerClient
  .then(function(client){


    return client.ProjectManagement.Projects.GetRevisionHistory(
      {
        projectId: value
      })
    .then(function(result) {
      console.log("then projm_getRevisionHistory ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      commit('GETREVISIONHISTORY', result.obj.data);

      return result.obj;
    }, function (reason) {
      console.log("init then projm_getRevisionHistory error");
      console.log(reason);
      
    });
  })


}

export const projm_getProject = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetProject(
        {
          projectRevisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then projm_getProject ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revision = obj.revisionId;
        return result.obj

      }, function (reason) {
        console.log("init then projm_getProject error");
        console.log(reason);
        
      });
    })

}  

export const projm_getProjectDetails = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetProjectDetails(
        {
          projectRevisionId: obj.projectRevisionId
        }
      )
      .then(function(result) {
        console.log("then projm_getProjectDetails ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revision = obj.revisionId;
        return result.obj

      }, function (reason) {
        console.log("init then projm_getProjectDetails error");
        console.log(reason);
        
      });
    })

} 
  

  
export const projm_importFiles = ({}, obj) => {

    return swaggerClient
    .then(function(client){
      
      return client.ProjectManagement.Projects.ImportFiles( {
        revisionId: obj.revisionId,
        lastModified: obj.lastModified
      },
      {
        requestBody: {file: obj.file}
      })
      .then(function(result) {
        console.log("then projm_importFiles ok");        
        if (result.statusText == "ERROR"){
          checkReason(result);
        }
        
        //result.obj.data.fileName = obj.fileName;
        
        return result.obj;
  
  
      }, function (reason) {
        console.log("then projm_importFiles error");
        console.log(reason);
        
      });
    })
  
}
  
export const projm_getFiles = ({}, obj) => {
  
  return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetFiles(
        {
          revisionId: obj.revisionId
        }
      )
      .then(function(result) {
        console.log("then projm_getFiles ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        
        result.obj.revision = obj.revisionId;
        return result.obj

      }, function (reason) {
        console.log("init then projm_getFiles error");
        console.log(reason);
        
      });
    })

}  


  
export const projm_downloadFile = ({}, obj) => {

        return swaggerClient
        .then(function(client){
    
          return client.ProjectManagement.Projects.DownloadFile(obj)
          .then(function(result) {
            console.log(result)
            console.log("projm_downloadFile ok");
            // if (result.obj.status == "ERROR"){
            //   checkReason(result);
            // }
            return result.data;
      
      
          }, function (reason) {
            console.log("projm_downloadFile error");
            console.log(reason);
            
          });
        })
      
}

export const projm_getProjectFiles = ({}, obj) => {

        return swaggerClient
        .then(function(client){
    
          return client.ProjectManagement.Projects.GetProjectFiles(obj)
          .then(function(result) {
            console.log(result)
            console.log("projm_getProjectFiles ok");
            // if (result.obj.status == "ERROR"){
            //   checkReason(result);
            // }
            return result.data;
      
      
          }, function (reason) {
            console.log("projm_getProjectFiles error");
            console.log(reason);
            
          });
        })
      
}

export const projm_deleteProjectFolderMapping = ({commit}) => {

  commit('DELETEPROJECTCATEGORYMAPPING')
}

export const projm_setElementFolderProject = ({commit}, value) => {

  commit('SETELEMENTCATEGORYFOLDER', value);

}

export const projm_selectTreeFolderItem = ({commit}, value) => {

  commit('SELECTTREEFOLDERITEM', value);

}

export const projm_selectTreeFolderItemObject = ({ commit }, value) => {
  commit("SELECTTREEFOLDERITEMOBJECT", value);
};

export const projm_reloadAfterDeleteTreeFolderItem = ({ commit }, value) => {
  commit("RELOADAFTERDELETETREEFOLDERITEM", value);
};

export const projm_deleteFolderMapping = ({commit}) => {

  commit('DELETEFOLDERMAPPING')
}

// export const projm_checkLibrary = ({  }, obj) => {
  
//   let revisionId = obj.revisionId;

  
//   console.log(obj);
//   return agentAPI.checkAvailability()
//     .then(function (isAvailable) {
//     console.log(isAvailable)
//     if(isAvailable){
//       return agentAPI.checkLibrary(revisionId);
//     } else {
//       return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
//     }
    

//   })
//   .then(null, agentAPI.wrapOutErrorPromise);

  
// }



// export const projm_getActiveLibraries = ({}, obj) => {

//         return swaggerClient
//         .then(function(client){
    
//           return client.LibraryManagement.Libraries.GetActiveLibraries( {
//             categoryId: obj.categoryId,
            
//           },
//           {
//             requestBody: obj.actions
//           })
//           .then(function(result) {
//             console.log(result)
//             console.log("lm_downloadFile ok");
//             // if (result.obj.status == "ERROR"){
//             //   checkReason(result);
//             // }
//             return result.data;
      
      
//           }, function (reason) {
//             console.log("lm_downloadFile error");
//             console.log(reason);
            
//           });
//         })
      
// }

export const projm_getFolderTree = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetFolderTree(obj)
    .then(function(result) {
      console.log("then projm_getFolderTree ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      
      return result.obj;
      
            
      
    }, function (reason) {
      console.log("projm_getFolderTree error");
      console.log(reason);
      
    });
  })


}

export const projm_createFolder = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.CreateFolder(obj)
    .then(function(result) {
      
      console.log("projm_createFolder ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_createFolder error");
      console.log(reason);
      
    });
  })
      
}

export const projm_createSubfolderForm = ({commit}, obj) => {

  commit('CREATESUBFOLDERFORM', obj);

}
export const projm_setVariantFolderForm = ({commit}, obj) => {

  commit('CREATEVARIANTFOLDERFORM', obj);

}


export const projm_deleteFolder = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.DeleteFolder(obj)
    .then(function(result) {
      
      console.log("projm_deleteFolder ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_deleteFolder error");
      console.log(reason);
      
    });
  })
      
}

export const projm_updateFolder = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.UpdateFolder(obj)
    .then(function(result) {
      console.log(result)
      console.log("projm_updateFolder ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_updateFolder error");
      console.log(reason);
      
    });
  })
      
}

export const projm_checkIfItemsInFolder = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.CheckIfItemsInFolder(obj)
    .then(function(result) {
      
      console.log("projm_checkIfItemsInFolder ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_checkIfItemsInFolder error");
      console.log(reason);
      
    });
  })
      
}

export const projm_deleteDocument = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.DeleteDocument(obj)
    .then(function(result) {
      console.log(result)
      console.log("projm_deleteDocument ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_deleteDocument error");
      console.log(reason);
      
    });
  })
      
}

export const projm_importDocument = ({}, obj) => {


    return swaggerClientFile
    .then(function(client){
  
      return client.ProjectManagement.Projects.ImportDocument(
        {
          projectRevisionId: obj.projectRevisionId,
          folderId: obj.folderId,
          modDate: obj.modDate
        },
        {
          requestBody: {file: obj.file}
        }
      )
      .then(function(result) {
        console.log("then projm_importDocument ok");
  
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("projm_importDocument error");
        console.log(reason);
        
      });
    })
  
  }

  export const projm_checkProject = ({  }, obj) => {
  
    let revisionId = obj.revisionId;
  
    
   
    return agentAPI.checkAvailability()
      .then(function (isAvailable) {
     
      if(isAvailable){
        return agentAPI.checkProject(revisionId);
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
      }
      
  
    })
    .then(null, agentAPI.wrapOutErrorPromise);
  
    
  }

export const projm_openProject = ({  }, obj) => {
  
  if ((obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL) && !store.getters.isPlugin) {
    
    return {status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"}
    return $.Deferred().reject({status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"});
  }

  let revisionId = obj.revisionId;
  
  let checkAvailabilityResult = null;
  let pullLibraryFilesResult = null;
  let openLibraryResult = null; 

  
  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
      checkAvailabilityResult = isAvailable;
      if (isAvailable) {
        return agentAPI.pullProjectFiles(revisionId)
          .then(function (result) {
          pullLibraryFilesResult = result;
          if (store.getters.isPlugin) {
//            return agentAPI.openProject(revisionId)
//              .then(function (result) {
//                openLibraryResult = result;
            let dsnPath = null;
            for (const fileflat of result.data.localFiles) {
              if (fileflat.folder.split('.').pop().toLowerCase() == 'dsn') {
                dsnPath = fileflat.folder;
                break;
              }
            }
            if(dsnPath != null) {
              return tclAPI.openProjectFromOmnya(dsnPath);
            } else {
              return agentAPI.openProjectNoPlugin(revisionId);
            }
                
//              })
          } else {
            return agentAPI.openProjectNoPlugin(revisionId);
          }
        })
        
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"});
      }

    })
    .then(function () {
      return $.Deferred().resolve({
        status: "OK", data: {
          checkAvailabilityResult: checkAvailabilityResult,
          pullLibraryFilesResult: pullLibraryFilesResult,
          openLibraryResult: openLibraryResult
        }
      })
    })
    .then(null, agentAPI.wrapOutErrorPromise);
}
export const projm_openProjectLocally = ({  }, obj) => {
  
  if ((obj.type === LibraryTypes.PART || obj.type === LibraryTypes.SYMBOL) && !store.getters.isPlugin) {
    
    return {status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"}
    return $.Deferred().reject({status:"ERROR",message:"Use Omnya Plugin inside Capture to manage schematic symbols libraries"});
  }

  let revisionId = obj.revisionId;
  
    
  let checkAvailabilityResult = null;
  let pullLibraryFilesResult = null;
  let openLibraryResult = null; 
    return agentAPI.checkAvailability()
      .then(function (isAvailable) {
        checkAvailabilityResult = isAvailable;
      if(isAvailable){
        return agentAPI.checkProject(revisionId);
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
      }
      
  
    })
    .then(function(result) {
      pullLibraryFilesResult = result;
        //TODO: check the status of the response and react adequatly on errors
        if (store.getters.isPlugin) {
            let dsnPath = null;
            for (const fileflat of result.data.localFiles) {
              if (fileflat.folder.split('.').pop().toLowerCase() == 'dsn') {
                dsnPath = fileflat.folder;
                break;
              }
            }
            if(dsnPath != null) {
              return tclAPI.openProjectFromOmnya(dsnPath);
            } else {
              return agentAPI.openProjectNoPlugin(revisionId);
            }
              
        } else {
          return agentAPI.openProjectNoPlugin(revisionId);
        }
    })
    .then(function () {
      return $.Deferred().resolve({
        status: "OK", data: {
          checkAvailabilityResult: checkAvailabilityResult,
          pullLibraryFilesResult: pullLibraryFilesResult/*,
          openLibraryResult: openLibraryResult*/
        }
      })
    })
    .then(null, agentAPI.wrapOutErrorPromise);
  
  
  

}

export const projm_pushProject = ({}, obj) => {

  let revisionId = obj.revisionId;
 
  

  return agentAPI.checkAvailability()
    .then(function (isAvailable) {
      if (isAvailable) {
        return agentAPI.checkProject(revisionId)
          .then(function(result){
            if (store.getters.isPlugin) {
                let dsnPath = null;
                for (const fileflat of result.data.localFiles) {
                  if (fileflat.folder.split('.').pop().toLowerCase() == 'dsn') {
                    dsnPath = fileflat.folder;
                    break;
                  }
                }
                if(dsnPath != null) {
                  return tclAPI.generateBomForOmnya(dsnPath,result.data.partNumberPropertyName)
                  ;
                }
              }
              // in any other case, not yet handled:
              
          })
          .then(function(){
            return agentAPI.pushProject(revisionId);
          })
        
      } else {
        return $.Deferred().reject({status:"ERROR",message:"Omnya local agent is not available"}).promise();
      }


    })
    .then(null, agentAPI.wrapOutErrorPromise);

  

}

export const projm_checkIn = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.CheckIn(
    {
      projectRevisionId: obj.projectRevisionId
    },
    {
      requestBody: {comment: obj.comment}
    })
    .then(function(result) {
      
      console.log("projm_checkIn ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_checkIn error");
      console.log(reason);
      
    });
  })
      
}

export const projm_checkOut = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.CheckOut(obj)
    .then(function(result) {
      
      console.log("projm_checkOut ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj;


    }, function (reason) {
      console.log("projm_checkOut error");
      console.log(reason);
      
    });
  })
      
}

export const projm_getBoms = ({  }, obj ) => {
  

  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.GetBoms(obj)
    .then(function(result) {
        console.log("then projm_getBoms ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_getBoms error");
      }
    );
  });
};

export const projm_setPreviewParts = ({commit}, obj) => {
  commit('SETPREVIEWPARTS', obj)
}


export const projm_setImportedFileId = ({commit}, value) => {
  commit('SETIMPORTEDFILEID', value);
}

export const projm_getBomProperties = ({  }, obj) => {
  

  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.GetBomProperties()
    .then(result => {
        console.log("then projm_getBomProperties ok");

        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("then projm_getBomProperties error ");
      }
    );
  });
};

export const projm_addMapField = ({ commit }, obj) => {
  commit("ADDMAPFIELD", obj);
};

export const projm_resetMapField = ({ commit }) => {
  commit("RESETMAPFIELD");
};

export const projm_MappingImportedBom = ({}, obj) => {
  

    const objBody = {
      
      _mapped: obj.mapped,
      description: obj.description,
           
      
    }
    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.MappingImportedBom(
        {
          projectRevisionId: obj.revisionId, documentId: obj.documentId, separator: obj.separator, name: obj.name, defaultRevision: obj.defaultRevision
        },
        {
          requestBody: objBody
        }
        )
      .then(function(result) {
        console.log("then projm_MappingImportedBom ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj


      }, function (reason) {
        console.log("init then projm_MappingImportedBom error");
        console.log(reason);
        
      });
    })

  }

  export const projm_setBomDescription = ({ commit }, obj) => {
    commit("SETBOMDESCRIPTION", obj);
  };
  export const projm_deleteBomDescription = ({ commit }) => {
    commit("DELETEBOMDESCRIPTION");
  };

  export const projm_setSelectedPartBomRow = ({ commit }, obj) => {
    commit("SETSELECTEDPARTBOMROW", obj);
  };

  export const projm_deleteSelectedPartBomRow = ({ commit }) => {
    commit("DELETESELECTEDPARTBOMROW");
};
  
export const projm_getBom = ({  }, obj ) => {
  
  
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.GetBom(obj)
    .then(function(result) {
        console.log("then projm_getBom ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_getBom error");
      }
    );
  });
};

export const projm_getBomExtended = ({  }, obj ) => {
  
  
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.GetBomExtended(obj)
    .then(function(result) {
        console.log("then projm_getBomExtended ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_getBomExtended error");
      }
    );
  });
};
export const projm_getBomExtendedAggregated = ({  }, obj ) => {
  
  
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.GetBomExtendedAggregated(obj)
    .then(function(result) {
        console.log("then projm_getBomExtendedAggregated ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_getBomExtendedAggregated error");
      }
    );
  });
};

export const projm_getBomAggregated = ({  }, obj ) => {
  
  
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.GetBomAggregated(obj)
    .then(function(result) {
        console.log("then projm_getBomAggregated ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_getBomAggregated error");
      }
    );
  });
};

export const projm_importBom = ({}, obj) => {

  
  return swaggerClientFile
  .then(function(client){

    return client.ProjectManagement.Projects.ImportBom(
      {
        projectRevisionId: obj.revisionId,
        separator: obj.separator
      },
      {
        requestBody: obj.file
      }
    )
    .then(function(result) {
      console.log("then projm_importBom ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("init then projm_importBom error");
      console.log(reason);
      
    });
  })

}

export const projm_setSelectedBomRow = ({commit}, obj) => {

  commit("SETSELECTEDBOMROW", obj);

}
export const projm_deleteSelectedBomRow = ({commit}) => {

  commit("DELETESELECTEDBOMROW");

}

export const projm_getBomWithPhysicals = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetBomWithPhysicals(obj)
    .then(function(result) {
      console.log("then projm_getBomWithPhysicals ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then projm_getBomWithPhysicals error");
      console.log(reason);
      
    });
  })

}

export const projm_getBomWithPhysicalsAggregated  = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetBomWithPhysicalsAggregated (obj)
    .then(function(result) {
      console.log("then projm_getBomWithPhysicalsAggregated ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then projm_getBomWithPhysicalsAggregated error");
      console.log(reason);
      
    });
  })

}

export const projm_selectPhysicalPartForBom = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.SelectPhysicalPartForBom(
    {
    },
    {
      requestBody: obj
    })
    .then(function(result) {
      console.log("then projm_selectPhysicalPartForBom ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then projm_selectPhysicalPartForBom error");
      console.log(reason);
      
    });
  })

}

export const projm_mapFolderToVariant = ({  }, obj ) => {
  

  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.MapFolderToVariant(obj)
    .then(function(result) {
        console.log("then projm_mapFolderToVariant ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_mapFolderToVariant error");
      }
    );
  });
};

export const projm_unmapFolderFromVariant = ({  }, obj ) => {
  

  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.UnmapFolderFromVariant(obj)
    .then(function(result) {
        console.log("then projm_unmapFolderFromVariant ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_unmapFolderFromVariant error");
      }
    );
  });
};

export const projm_getPhysicals = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPhysicals(obj)
      .then(function(result) {
        console.log("then projm_getPhysicals ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_getPhysicals error");
        console.log(reason);
        
      });
    })
  
}

export const projm_getPhysicalsAssembly = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.PartManagement.Parts.GetPhysicalsAssembly(obj)
      .then(function(result) {
        console.log("then projm_getPhysicalsAssembly ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_getPhysicalsAssembly error");
        console.log(reason);
        
      });
    })
  
}
  
export const projm_getVariants = ({commit}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetVariants(obj)
      .then(function(result) {
        console.log("then projm_getVariants ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        commit("SETVARIANTS", result.obj.data);
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_getVariants error");
        console.log(reason);
        
      });
    })
  
}
  
export const projm_deleteBom = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.DeleteBom(obj)
      .then(function(result) {
        console.log("then projm_deleteBom ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_deleteBom error");
        console.log(reason);
        
      });
    })
  
}

export const projm_projectChangeReport = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.ProjectChangeReport(obj)
      .then(function(result) {
        console.log("then projm_projectChangeReport ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_projectChangeReport error");
        console.log(reason);
        
      });
    })
  
}
export const projm_isBomInProject = ({commit}, value) => {
        
  commit("ISBOMINPROJECT", value);
}
export const projm_setBomActive = ({}, obj) => {

        return swaggerClient
        .then(function(client){
    
          return client.ProjectManagement.Projects.SetBomActive(obj)
          .then(function(result) {
            console.log("then projm_setBomActive ok");
            if (result.obj.status == "ERROR"){
              checkReason(result);
            }
            return result.obj
      
      
          }, function (reason) {
            console.log("then projm_setBomActive error");
            console.log(reason);
            
          });
        })
      
}
      
export const projm_bulkDeleteProject = ({ }, obj) => {
  
    
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.BulkDeleteProject({},
      {
        requestBody: obj.projectIds
      })
    .then(function(result) {
        console.log("then projm_bulkDeleteProject ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_bulkDeleteProject error");
      }
    );
  });
};

export const projm_setEventTaskForm = ({commit}, obj) => {

    commit("SETEVENTTASKFORM", obj)
}

export const projm_deriveProject = ({  }, obj) => {



  return swaggerClient.then(client => {
    return client.ProjectManagement.Projects.DeriveProject(
      { 
        categoryId: obj.categoryId,
        projectRevisionId: obj.projectRevisionId,
      },
      {
        requestBody: obj.values
      })
    .then(
      result => {
        console.log(" projm_deriveProject ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      },
      reason => {
        console.log(reason);
        console.log("error projm_deriveProject");
      }
    );
  });
};

export const projm_getFilesComparison = ({  }, obj ) => {
  
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.FilesComparison({ 
        
      },
      {
        requestBody: obj
      })
    .then(function(result) {
        console.log("then projm_filesComparison ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_filesComparison error");
      }
    );
  });
};

export const projm_bomComparison = ({  }, obj ) => {
  
  return swaggerClient.then(function(client){
    return client.ProjectManagement.Projects.BomComparison(obj)
    .then(function(result) {
        console.log("then projm_bomComparison ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }

        return result.obj;
      }, function (reason) {
        console.log(reason);
        console.log("then projm_bomComparison error");
      }
    );
  });
};

export const projm_setExtensions = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.SetExtensions(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then projm_setExtensions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_setExtensions error");
      console.log(reason);

    });
  })

}

export const projm_getExtensions = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetExtensions()
    .then(function(result) {
      console.log("then projm_getExtensions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_getExtensions error");
      console.log(reason);

    });
  })

}

export const projm_renaming = ({commit}, obj) => {

    commit("RENAMING", obj)
}

export const projm_changeProjectNumber = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.ChangeProjectNumber(obj)
    .then(function(result) {
      console.log("then projm_changeProjectNumber ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_changeProjectNumber error");
      console.log(reason);

    });
  })

}

export const projm_bulkCheckMovingToAnotherCategory = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.BulkCheckMovingToAnotherCategory(
      {},
      {
        requestBody: obj
      })
    .then(function(result) {
      console.log("then projm_bulkCheckMovingToAnotherCategory ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_bulkCheckMovingToAnotherCategory error");
      console.log(reason);

    });
  })

}

export const projm_bulkMoveToAnotherCategory = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.BulkMoveToAnotherCategory(
      {},
      {
        requestBody: obj
      })
    .then(function(result) {
      console.log("then projm_bulkMoveToAnotherCategory ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_bulkMoveToAnotherCategory error");
      console.log(reason);

    });
  })

}

export const projm_getFlatCategories = ({}) => {



  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetTree()
    .then(function(result) {
      console.log("projm_getFlatCategories ok");

      //commit('GETDATATREE', result.obj.data);
      return result.obj
      
      

    }, function (reason) {
      console.log("projm_getFlatCategories error");
      console.log(reason);
      
    });
  })

}

export const projm_moving = ({commit}, obj) => {

    commit("MOVING", obj)
}

export const projm_delegateFolder = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.DelegateFolder(obj)
    .then(function(result) {
      console.log("then projm_delegateFolder ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_delegateFolder error");
      console.log(reason);

    });
  })

}

export const projm_undoDelegateFolder = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.UndoDelegateFolder(obj)
    .then(function(result) {
      console.log("then projm_undoDelegateFolder ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_undoDelegateFolder error");
      console.log(reason);

    });
  })

}

export const projm_confirmResourceFolder = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.ConfirmResourceFolder(obj)
    .then(function(result) {
      console.log("then projm_confirmResourceFolder ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_confirmResourceFolder error");
      console.log(reason);

    });
  })

}

export const projm_rejectDelegationFolder = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.RejectDelegationFolder(
      {
        folderId: obj.folderId
      },
      {
         requestBody: "\""+obj.reason+"\""
      }
      )
    .then(function(result) {
      console.log("then projm_rejectDelegationFolder ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_rejectDelegationFolder error");
      console.log(reason);

    });
  })

}

export const projm_delegateFile = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.DelegateFile(obj)
    .then(function(result) {
      console.log("then projm_delegateFile ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_delegateFile error");
      console.log(reason);

    });
  })

}

export const projm_undoDelegateFile = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.UndoDelegateFile(obj)
    .then(function(result) {
      console.log("then projm_undoDelegateFile ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_undoDelegateFile error");
      console.log(reason);

    });
  })

}

export const projm_confirmResourceFile = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.ConfirmResourceFile(obj)
    .then(function(result) {
      console.log("then projm_confirmResourceFile ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_confirmResourceFile error");
      console.log(reason);

    });
  })

}

export const projm_rejectDelegationFile = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.RejectDelegationFile(
      {
        fileId: obj.fileId
      },
      {
        requestBody: "\""+obj.reason+"\""
      }
    )
    .then(function(result) {
      console.log("then projm_rejectDelegationFile ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_rejectDelegationFile error");
      console.log(reason);

    });
  })

}

export const projm_delegationForm = ({commit}, obj) => {

  commit("DELEGATION", obj);
}

export const projm_delegatedResource = ({commit}, value) => {
  
  commit("SETDELEGATEDRESOURCE", value);
}

export const projm_getDelegationReport = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.GetDelegationReport(obj)
    .then(function(result) {
      console.log("then projm_getDelegationReport ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_getDelegationReport error");
      console.log(reason);

    });
  })

}

export const projm_changePropertyPriority = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.ChangePropertyPriority(
      {

      },
      {
        requestBody: obj
      }  
    )
    .then(function(result) {
      console.log("then projm_changePropertyPriority ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_changePropertyPriority error");
      console.log(reason);

    });
  })

}

export const projm_getAutocompleteValues = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.ProjectManagement.Projects.GetAutocompleteValues(obj)
    .then(function(result) {
      console.log("then projm_getAutocompleteValues ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_getAutocompleteValues error");
      console.log(reason);

    });
  })

}

export const projm_whatIsIncluded = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.WhatIsIncluded(obj)
      .then(function(result) {
        console.log("then projm_whatIsIncluded ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_whatIsIncluded error");
        console.log(reason);
        
      });
    })
  
}

export const projm_isBom = ({commit}, value) => {
  commit('ISBOM', value);
}

export const projm_importBomTypeForm = ({commit}, obj) => {
  commit('IMPORTBOMTYPEFORM', obj);
}

export const projm_createBomVariant = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.CreateBomVariant(
      {

      },
      {
        requestBody: obj
      }  
    )
    .then(function(result) {
      console.log("then projm_createBomVariant ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_createBomVariant error");
      console.log(reason);

    });
  })

}

export const projm_createBomVariantForm = ({commit}, obj) => {
  commit('CREATEBOMVARIANTFORM', obj);
}

export const projm_createNewBomPart = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.CreateNewBomPart(
      {
        bomId: obj.bomId
      },
      {
        requestBody: [{
          partNumber: obj.partNumber,
          revision: obj.revision,
          partReference: obj.partReference,
          description: obj.description
        }]
      }  
    )
    .then(function(result) {
      console.log("then projm_createNewBomPart ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_createNewBomPart error");
      console.log(reason);

    });
  })

}

export const projm_updateBomPart = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.UpdateBomPart(
      {
        
      },
      {
        requestBody: obj
      }  
    )
    .then(function(result) {
      console.log("then projm_updateBomPart ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_updateBomPart error");
      console.log(reason);

    });
  })

}

export const projm_updateBomPartAggregated = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.UpdateBomPartAggregated(
      {
        
      },
      {
        requestBody: obj
      }  
    )
    .then(function(result) {
      console.log("then projm_updateBomPartAggregated ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_updateBomPartAggregated error");
      console.log(reason);

    });
  })

}

export const projm_deleteBomPart = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.DeleteBomPart(obj)
      .then(function(result) {
        console.log("then projm_deleteBomPart ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_deleteBomPart error");
        console.log(reason);
        
      });
    })
  
}

export const projm_deleteBomPartAggregated = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.DeleteBomPartAggregated(
        {
        
      },
      {
        requestBody: obj
      }  
      )
      .then(function(result) {
        console.log("then projm_deleteBomPartAggregated ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_deleteBomPartAggregated error");
        console.log(reason);
        
      });
    })
  
}

export const projm_bomPartObjectForm = ({commit}, obj) => {
  commit('CREATEBOMPARTOBJECTFORM', obj);
}

export const projm_importIpc = ({}, obj) => {


        return swaggerClientFile
        .then(function(client){
      
          return client.ProjectManagement.Projects.ImportIpc(
            {
              projectRevisionId: obj.projectRevisionId
            },
            {
              requestBody: obj.file
            }
          )
          .then(function(result) {
            console.log("projm_importIPC ok");
      
            if (result.obj.status == "ERROR"){
              checkReason(result);
            }
            return result.obj
      
      
          }, function (reason) {
            console.log("projm_importIPC error");
            console.log(reason);
            
          });
        })
      
      }
    
      export const projm_getSvgFromIpc = ({}, obj) => {

        return swaggerClient
        .then(function(client){
          
          return client.ProjectManagement.Projects.GetSvgFromIpc(obj)
          .then(function(result) {
            console.log("then projm_getSvgFromIpc ok");
            if (result.statusText == "ERROR"){
              checkReason(result);
            }
            
            return result.data
      
      
          }, function (reason) {
            console.log("then projm_getSvgFromIpc error");
            console.log(reason);
            
          });
        })
      
}
      
export const projm_importBomLst = ({}, obj) => {


    return swaggerClientFile
    .then(function(client){
  
      return client.ProjectManagement.Projects.ImportBomLST(
        {
          projectRevisionId: obj.projectRevisionId
        },
        {
          requestBody: obj.file
        }
      )
      .then(function(result) {
        console.log("projm_importBomLst ok");
  
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("projm_importBomLst error");
        console.log(reason);
        
      });
    })
  
}
  
export const projm_setCheckboxVariant = ({ commit }, obj) => {
  commit("SETCHECKBOXVARIANT", obj);
};
export const projm_removeCheckboxVariant = ({ commit }) => {
  commit("REMOVECHECKBOXVARIANT");
};

export const projm_getCategories = ({commit}) => {



  swaggerClient
  .then(function(client){

    client.PartManagement.Parts.GetTree()
    .then(function(result) {
      console.log("then getTree ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      commit('GETDATATREE', result.obj.data);
      
      console.log(store.getters.selectedTreeItemObject)
      if (store.getters.selectedTreeItemObject == ""){
        const obj = result.obj.data;
        obj.children = [];

        commit("SELECTTREEITEMOBJECT", obj);
      }

      
      
    }, function (reason) {
      console.log("init then getData error");
      console.log(reason);
      
    });
  })

}

export const setSelectedSearchPartRows = ({commit}, value) => {

  commit('SETSELECTEDSEARCHPARTROWS', value);
  

}

export const deleteAllSelectedSearchPartRows = ({commit}) => {

  commit('DELETEALLSELECTEDSEARCHPARTROWS');
  

}

export const projm_noIpcImage = ({ commit }, value) => {
  
  commit('SETIPCIMAGESTATUS', value);
}

export const projm_removeSvgFromIpc = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.RemoveSvgFromIpc(obj)
      .then(function(result) {
        console.log("then projm_removeSvgFromIpc ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_removeSvgFromIpc error");
        console.log(reason);
        
      });
    })
  
}

export const projm_getUsedLibraries = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetUsedLibraries(obj)
      .then(function(result) {
        console.log("then projm_getUsedLibraries ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_getUsedLibraries error");
        console.log(reason);
        
      });
    })
  
}

export const projm_setNotPresent = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.SetNotPresent(obj)
      .then(function(result) {
        console.log("then projm_setNotPresent ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_setNotPresent error");
        console.log(reason);
        
      });
    })
  
}

export const projm_setNotPresentAggregated = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.SetNotPresentAggregated(
        {
          
        },
        {
          requestBody: obj
        }
      )
      .then(function(result) {
        console.log("then projm_setNotPresentAggregated ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_setNotPresentAggregated error");
        console.log(reason);
        
      });
    })
  
}

export const projm_getCategoryByRevisionId = ({  }, obj) => {
  
  return swaggerClient
  .then(function(client){

    
    return client.ProjectManagement.Projects.GetCategoryByRevisionId(obj)
    .then(function(result) {
      console.log("then pm_getCategoryByRevisionId ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then pm_getCategoryByRevisionId error");
      console.log(reason);

    });
  })

}
export const projm_transferOfOwnership = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.TransferOfOwnership(obj)
    .then(function(result) {
      console.log("then projm_transferOfOwnership ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_transferOfOwnership error");
      console.log(reason);

    });
  })

}
export const projm_setRevisionAsArchive = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.ProjectManagement.Projects.SetRevisionAsArchive(obj)
    .then(function(result) {
      console.log("then projm_setRevisionAsArchive ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then projm_setRevisionAsArchive error");
      console.log(reason);

    });
  })

}

export const projm_bomComparisonForRevisions = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.BOMComparisonForRevisions(
        {
          
        },
        {
          requestBody: obj.bomIds
        }
      )
      .then(function(result) {
        console.log("then projm_bomComparisonForRevisions ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_bomComparisonForRevisions error");
        console.log(reason);
        
      });
    })
  
}

export const projm_setProjectSpec = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.SetProjectSpec(
        {
          
        },
        {
          requestBody: obj
        }
      )
      .then(function(result) {
        console.log("then projm_setProjectSpec ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_setProjectSpec error");
        console.log(reason);
        
      });
    })
  
}

export const projm_getProjectSpec = ({}, obj) => {

    return swaggerClient
    .then(function(client){

      return client.ProjectManagement.Projects.GetProjectSpec(obj)
      .then(function(result) {
        console.log("then projm_getProjectSpec ok");
        if (result.obj.status == "ERROR"){
          checkReason(result);
        }
        return result.obj
  
  
      }, function (reason) {
        console.log("then projm_getProjectSpec error");
        console.log(reason);
        
      });
    })
  
}

//rm - Request Manager #############################################################################

export const rm_createRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    console.log(obj)
    return client.RequestManagement.Requests.CreateRequest(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_createRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_createRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_updateRequest = ({}, obj) => {
console.log(obj)
  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.UpdateRequest(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_updateRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_updateRequest error");
      console.log(reason);
      
    });
  })

}



export const rm_addActiveFilter = ({commit}, value) => {

  commit('RM_ADDACTIVEFILTER', value);

}

export const rm_deleteActiveFilter = ({commit}, value) => {

  commit('RM_DELETEACTIVEFILTER', value);

}

export const rm_deleteAllActiveFilters = ({commit}) => {

  commit('RM_DELETEALLACTIVEFILTERS');

}

export const rm_addActiveAction = ({commit}, obj) => {

  commit('RM_ADDACTIVEACTION', obj);

}

export const rm_deleteActiveAction = ({commit}, obj) => {

  commit('RM_DELETEACTIVEACTION', obj);

}

export const rm_deleteAllActiveActions = ({commit}) => {

  commit('RM_DELETEALLACTIVEACTIONS');

}

export const rm_getActions = ({ commit }, obj) => {

  
  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetActions(obj)
    .then(function(result) {
      console.log("then rm_getActions ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_getActions error");
      console.log(reason);
      
    });
  })

}

export const rm_bindPartToRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.BindPartToRequest(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_bindPartToRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_bindPartToRequest error");
      console.log(reason);
      
    });
  })

}
export const rm_bindLibraryToRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.BindLibraryToRequest(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_bindLibraryToRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_bindLibraryToRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_deleteRequestFile = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.DeleteRequestFile(obj)
    .then(function(result) {
      console.log("then rm_deleteRequestFile ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_deleteRequestFile error");
      console.log(reason);
      
    });
  })

}

export const rm_downloadFile = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.DownloadFile(obj)
    .then(function(result) {
      console.log("then rm_downloadFile ok");
      // if (result.obj.status == "ERROR"){
      //   checkReason(result);
      // }
       return result.data;


    }, function (reason) {
      console.log("then rm_downloadFile error");
      console.log(reason);
      
    });
  })

}

export const rm_getRequestDetails = ({ }, obj) => {
  
  
  
  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetRequestDetails(obj)
    .then(function(result) {
      console.log("then rm_getRequestDetails ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_getRequestDetails error");
      console.log(reason);
      
    });
  })

}

export const rm_createLibRequest = ({ }, obj) => {

  
  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.CreateLibRequest(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_createLibRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_createLibRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_setCategory = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.SetCategory(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_setCategory ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_setCategory error");
      console.log(reason);
      
    });
  })

}

export const rm_assignRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.AssignRequest(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_assignRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_assignRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_startRequestDevelopment = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.StartRequestDevelopment(obj)
    .then(function(result) {
      console.log("then rm_startRequestDevelopment ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_startRequestDevelopment error");
      console.log(reason);
      
    });
  })

}

export const rm_getMPNDetails = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetMPNDetails(obj)
    .then(function(result) {
      console.log("then rm_getMPNDetails ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_getMPNDetails error");
      console.log(reason);
      
    });
  })

}

export const rm_getHistory = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetHistory(obj)
    .then(function(result) {
      console.log("then rm_getHistory ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_getHistory error");
      console.log(reason);
      
    });
  })

}

export const rm_updateRequestValidation = ({ }, obj) => {
  
  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.UpdateRequestValidation(
      {
        
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_updateRequestValidation ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_updateRequestValidation error");
      console.log(reason);
      
    });
  })

}


export const rm_importRequestFile = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.ImportRequestFile({
      requestId: obj.requestId,
      lastModified: obj.lastModified
    },
    {
      requestBody: {file: obj.file}
    })
    .then(function(result) {
      console.log("then rm_importRequestFile ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
      //result.obj.data.fileName = obj.fileName;
      
      return result.obj;


    }, function (reason) {
      console.log("then rm_importRequestFile error");
      console.log(reason);
      
    });
  })

}

export const rm_submitRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.SubmitRequest(obj)
    .then(function(result) {
      console.log("then rm_submitRequest ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then rm_submitRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_cancelRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.CancelRequest(obj)
    .then(function(result) {
      console.log("then rm_cancelRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_cancelRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_ownRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.OwnRequest(obj)
    .then(function(result) {
      console.log("then rm_ownRequest ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then rm_ownRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_disownRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.DisownRequest(obj)
    .then(function(result) {
      console.log("then rm_disownRequest ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then rm_disownRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_returnToRequester = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.ReturnToRequester(
      {
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then returnToRequester ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then returnToRequester error");
      console.log(reason);
      
    });
  })

}

export const rm_assignLibrarian = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.AssignLibrarian(obj)
    .then(function(result) {
      console.log("then assignLibrarian ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then assignLibrarian error");
      console.log(reason);
      
    });
  })

}

export const rm_doneRequestDevelopment = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.DoneRequestDevelopment(
      {
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then doneRequestDevelopment ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then doneRequestDevelopment error");
      console.log(reason);
      
    });
  })

}

export const rm_returnRequestForRework = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.ReturnRequestForRework({
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then returnRequestForRework ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then returnRequestForRework error");
      console.log(reason);
      
    });
  })

}

export const rm_releaseRequestForEvaluation = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.ReleaseRequestForEvaluation(obj)
    .then(function(result) {
      console.log("then releaseRequestForEvaluation ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then releaseRequestForEvaluation error");
      console.log(reason);
      
    });
  })

}

export const rm_releaseRequestForProduction = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.ReleaseRequestForProduction(
      {
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then releaseRequestForProduction ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then releaseRequestForProduction error");
      console.log(reason);
      
    });
  })

}

export const rm_withdrawRequest = ({}, obj) => {

  return swaggerClient
  .then(function(client){
    
    return client.RequestManagement.Requests.WithdrawRequest(
      {
      },
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then withdrawRequest ok");        
      if (result.statusText == "ERROR"){
        checkReason(result);
      }
      
            
      return result.obj;


    }, function (reason) {
      console.log("then withdrawRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_getRequest = ({ }, obj) => {
  
  
  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetRequest(obj)
    .then(function(result) {
      console.log("then rm_getRequest ok");
      if (result.obj.status == "ERROR"){
        checkReason(result);
      }
      return result.obj


    }, function (reason) {
      console.log("then rm_getRequest error");
      console.log(reason);
      
    });
  })

}

export const rm_setExtensions = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.SetExtensions(
      {},
      {
        requestBody: obj
      }
    )
    .then(function(result) {
      console.log("then rm_setExtensions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then rm_setExtensions error");
      console.log(reason);

    });
  })

}

export const rm_getExtensions = ({}, obj) => {


  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetExtensions()
    .then(function(result) {
      console.log("then rm_getExtensions ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then rm_getExtensions error");
      console.log(reason);

    });
  })

}

export const rm_getUsersRequest = ({ }, obj) => {
  
  

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetUsersRequest(obj)
    .then(function(result) {
      console.log("then rm_getUsersRequest ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then rm_getUsersRequest error");
      console.log(reason);

    });
  })

}

export const rm_getHistoryComments = ({ }, obj) => {
  
  

  return swaggerClient
  .then(function(client){

    return client.RequestManagement.Requests.GetHistoryComments(obj)
    .then(function(result) {
      console.log("then rm_getHistoryComments ok");

      if (result.obj.status == "ERROR"){
        checkReason(result);
      }

      return result.obj;


    }, function (reason) {
      console.log("then rm_getHistoryComments error");
      console.log(reason);

    });
  })

}


// WEBPACK FOOTER //
// ./src/store/actions.js